export const headerName = {
    mdumRouteConstant: 'mdum/v2',
    routeConstant: 'service-requests/v6',
    routeConstantv7: 'service-requests/v7',
    orderTrackerApplicationName: 'Order Tracker',
    number: 'Number',
    name: 'Name',
    item: 'Item',
    customerReference: 'Your reference',
    requestedFor: 'Requested for',
    opened: 'Opened',
    placed: 'Placed',
    relatedOrder: 'Related order',
    estimated: 'Estimated',
    estimatedFulfilment: 'Estimated fulfilment',
    status: 'Status',
    comingSoon: 'Coming soon',
    requestHeader: 'Requests',
    trackingHeader: 'Tracking',
    yourRequestHeader: 'Your requests',
    Manage: 'Manage',
    refresh: 'Refresh',
    trackRequests: 'Track requests',
    locations: 'Locations',
    services: 'Services',
    openTab: 'Open',
    closedTab: 'Closed',
    newRequest: 'New request',
    tryAgain: 'Try again',
    viewAll: 'View all',
    createRequestButton: 'Create request',
    configurationSettings: 'Settings',
    serviceInformation: 'Service information',
    generalInformation: 'General information',
    createNew: 'Create new',
    onTrackStatus: 'On track',
    onHoldStatus: 'On hold',
    delayedStatus: 'Delayed',
    completeStatus: 'Complete',
    withdrawnStatus: 'Withdrawn',
    createRequest: 'Create new request',
    newRequestCreation: 'Create a new request',
    internationalBusinessUnit: 'international',
    domesticBusinessUnit: 'domestic',
    summaryHeader: 'Summary',
    activityHeader: 'Activity',
    summaryItem: 'Item',
    officalReference: 'Telstra reference',
    summaryRefrence: 'Your reference',
    summaryCurrentProgress: 'Current progress',
    location: 'Location',
    progressStage: 'Progress stage',
    activity: 'Updates',
    summaryName: 'Summary',
    success: 'Request submitted',
    error: 'Error',
    true: 'True',
    false: 'False',
    next: 'Next',
    search: 'Search',
    submit: 'Submit',
    gotoServicePage: 'Go to service page',
    requestType: 'Request type',
    checkbox: 'CheckBox',
    typeahead: 'Typeahead',
    macro: 'Macro',
    macroWithLabel: 'Macro with Label',
    label: 'Label',
    date: 'Date',
    dateTime: 'Date/Time',
    dateRange: 'Date Range',
    dateRangeIntRoam: 'DateRange',
    dateTimeRange: 'DateTime Range',
    dataSelection: 'Select Date/Time',
    dateSelection: 'Select Date',
    multipleChoice: 'Multiple Choice',
    yesNo: 'Yes / No',
    reference: 'Reference',
    selectBox: 'Select Box',
    singleLineText: 'Single Line Text',
    multiLineText: 'Multi Line Text',
    productType: 'Single Line Text1',
    email: 'Email',
    break: 'Break',
    chartName: 'SRMPieChart',
    loadingData: 'Loading data',
    loading: 'Loading...',
    reload: 'Reload',
    inlineSpinner: 'InlineSpinner',
    resize: 'resize',
    review: 'Review',
    submitRequest: 'Submit request',
    requestId: 'Request ID ',
    itemReference: 'Item reference',
    previousUpdates: 'Previous updates',
    mobileDevicesHeader: 'Mobile device management',
    dashBoardBreadcrumb: 'Dashboard',
    devices: 'Mobile devices',
    topTenapps: 'Top ten apps',
    mobileDevicesManagement: 'Mobile device management',
    tidcategory: 'Telstra Internet Direct',
    deviceInformation: 'Device information',
    enrolmentStatus: 'Enrolment status',
    deviceDetails: 'Device details',
    device: 'Device',
    imeiSerial: 'IMEI / Serial',
    mdmOwnershipType: 'MDM Ownership type',
    lastSeenDate: 'Last seen date',
    userDetails: 'User details',
    planDetails: 'Plan details',
    complianceDetails: 'Compliance details',
    firstName: 'First name',
    lastName: 'Last name',
    userName: 'Username',
    chargeable: 'Chargeable',
    telstraEligiblePlan: 'Telstra eligible plan',
    policyName: 'Policy name',
    complianceStatus: 'Compliance status',
    policyDetail: 'Policy detail',
    lastComplianceCheck: 'Last compliance check',
    nextComplianceCheck: 'Next compliance check',
    imei: 'IMEI',
    planType: 'planType',
    serverErrorText: 'Server Error',
    yourDevicesText: 'Your devices',
    totalText: 'Total',
    nonCompliantText: 'Non-compliant',
    chargeableText: 'Chargeable',
    enroledText: 'Enroled',
    unEnroledText: 'Unenroled',
    otherDevicesText: 'Other devices',
    chargeableAlertText: 'Devices that do not have MDM subscription as part of their plan',
    otherAlertFirstHalf: 'Devices with a status that is not "Enroled" or "Unenroled".',
    otherAlertSecondText: 'This could include devices waiting for deletion.',
    devicesText: 'devices',
    enrolmentText: 'enrolments',
    noDataText: 'No data',
    enrolmentHistoryText: 'Enrolment history',
    pastWeekText: 'Past week',
    lastSeenText: 'Last seen',
    thirtyDays: ' +30 days',
    ManagedDevicesAndApps: 'Managed devices and apps',
    mdmDevice: 'Device',
    imeiNo: 'IMEI / Serial',
    mdmUser: 'User',
    enrollmentStatus: 'Enrollment Status',
    chargeableStatus: 'Chargeable',
    topTenAppName: 'App name',
    osName: 'OS',
    appType: 'App Type',
    appVersion: 'App version',
    devicesCount: 'Devices count',
    save: 'Save',
    cancel: 'Cancel',
    description: 'Description',
    custLabel: 'custLabel',
    phone: 'Phone',
    phone1: 'Phone1',
    phone2: 'Phone2',
    maximOnly: 'maximOnly',
    maximType2CatItemKey: '1585043931',
    emailOnly: 'emailOnly',
    summaryProductType: 'Product / service',
    displayDetailsOnSummaryPage: 'Details',
    maximType2Form: 'Maxim-GeneralRequest-Redux-Form',
    summeryDownloadableAttachments: 'Attachments',
    yourServices: 'Your services',
    mobile_plans_devices: 'Mobile plans and devices',
    readOnlyUser: 'READ_ONLY',
    viewFAQ: 'View FAQs',
    searchResults: 'Search Results',
    featureNetworkChange: 'Feature Network Change',
    fncSuccessHeader: 'Feature Network Change submitted',
    changeId: 'Change ID ',
    banner: 'Banner',
    ypsLandingPageHeader: 'Your products and services',
    track: 'Track',
    YTTHeader: 'Your Telstra Tools',
    TelstraPartnerHeader: 'Telstra partner',
    loopback: 'Loopback test',
    PortReset: 'Port reset',
    NTDReset: 'NTD reset (coming soon)',
    NTDResetTest: 'NTD reset',
    requestCataloguePageHeader: 'Request catalogue',
    nbn: 'nbn',
    TM: 'TM',
    networkTest: 'network tests',
    nbnServices: 'Your services',
    nbnIntroHeader: 'For Telstra broadband bundles',
    loopbackTesting: 'Loopback testing ',
    portresetting: 'Port resetting ',
    dashboardTileHeader: 'dashboard title header',
    loopbackPassed: 'Loopback passed:',
    loopbackFailed: 'Loopback failed:',
    portresetComplete: 'Port reset complete:',
    portresetFailed: 'Port reset failed:',
    portresetIncomplete: 'Port reset incomplete:',
    loopbackIncomplete: 'Loopback incomplete:',
    assistiveTextinfo: 'assistiveText-info',
    checkBoxGroup: 'CheckBox Group',
    deactivateService: 'Deactivate service',
    continue: 'Continue',
    submitSupportEnquiry: 'Submit support enquiry',
    serviceTitle: 'Service configuration and reporting tools',
    serviceDes: 'Manage and configure your IP services and view network reports.',
    lrmSubpath: '/v2/logical-resources/resources/sim/query',
    tnRequestCatalogue: 'your-products-and-services/mobility-solutions/request-catalogue?from=TN',
    reactivatePassDueDateFormHeader: 'Activate a new service',
    reactivatePassDueDateNewNumberCatItemKey: 'reactivate-with-new-number',
    reactivatePassDueDateExistingNumberCatItemKey: 'reactivate-with-existing-number',
    reactivateWithinDueDateCatItemKey: 'reactivate-within-due-date',
    nbnSummary: 'Summary',
    nbnHistory: 'Recent test results',
    fncAdditionalInformation: 'Additional information',
    viewAllRequestListUnifiedTrackListButton: (buttonName: string, count: string) =>
        `View all ${buttonName} (${count})`,
    tempSuspSubheader: 'Need to divert calls? (optional)',
    maximGeneralForm: 'General request form',
    mobileServicesFormName: 'Mobile services',
    createNewDeliveryContact: 'Create new delivery contact',
    useExistingContact: 'Use existing contact',
    deliveryContact: 'Delivery contact',
    deliveryContactEmail: 'Email',
    deliveryContactNumber: 'Contact number',
    deliveryContactID: 'Contact ID',
    deliveryAdborID: 'ADBoR ID',
    deliveryAddress: 'Delivery address',
    legacyMobilityCatalogueGroupKey: '8f3c58bb879de11081bcb8809bbb3523',
    deactivateKeyForTnowForm: 'b4d8e8fb87afe51081bcb8809bbb3580',
    adaptiveMobilitySimReplacementKey: '4c22a034dbdfd010beee52e3449619ba',
    simReplacementKey: 'e37ff5dfdb100090e571da857a961957',
    suspendMobileServiceKey: '4a521694db6dcc1052ba147a3a961941',
    resumeMobileServiceKey: '4e7d4714db61005052ba147a3a96193a',
    dashboardTileHeaderName: 'Your products and services',
    dashboardTileCreateRequest: 'Create request',
    dashboardTileMobilitySolutionsLink: 'Mobility solutions',
    dashboardTileRefresh: 'Refresh',
    mobileServiceDetailPageCreateRequestButtonLabel: 'Create a request',
    dashboardTileTrackRequests: 'Track requests',
    deactivateFormName: 'Deactivate',
    newDeactivateFormName: 'Deactivate a mobile service',
    newDeactivateFormNameKey: 'b4d8e8fb87afe51081bcb8809bbb3580',
    reactivateFormName: 'Reactivate',
    tempSuspensionFormName: 'Temporarily Suspend',
    yourServiceRefBlockLabel: 'Your service reference',
    needToMakeChange: 'Need to make another type of change?',
    streetNumber: 'streetNumber',
    streetName: 'streetName',
    streetType: 'streetType',
    suburb: 'suburb',
    stateProvince: 'stateProvince',
    postCode: 'postCode',
    unitType: 'unitType',
    unitNumber: 'unitNumber',
    searchMobileNumberLabel: 'Search mobile number',
    incorrectMobileServiceContractEndDate: '2999-12-31',
    leavingTConnectPageModalHeader: 'You\'re now leaving Telstra Connect',
    enableIntRoamModalHeader: 'Enable international roaming',
    disableIntRoamModalHeader: 'Disable international roaming',
    proceedToIntRoaming: (buttonName: string) => `Proceed to ${buttonName} roaming`,
    cancelEnableRoaming: 'Cancel enabling roaming',
    ourCustomerTerms: 'Our Customer Terms',
    intRoamEligibleCountries: 'eligible countries',
    intRoamSessionStorageName: 'intRoamSessionStorage',
    iDDSessionStorageName: 'iDDSessionStorageName',
    apnSessionStorageName: 'apnSessionStorageName',
    mmsSessionStorageName: 'mmsSessionStorageName',
    voicemailSessionStorageName: 'voicemailSessionStorageName',
    reacSessionStorageName: 'reacSessionStorageName',
    deacSessionStorageName: 'deacSessionStorageName',
    strategicNeedToMakeChange: 'Need to make a change?',
    apn: 'Access Point Name (APN)',
    serviceTerms: 'service terms',
    capitalServiceTerms: 'Service Terms',
    supportEnquiry: 'support enquiry',
    getSupport: 'Get support',
    apnAdd: 'Add APN',
    apnRemove: 'Remove APN',
    apnRemoveDefault: 'Default APN to access data',
    apnRemoveUserEnter: 'Enter an APN',
    mmsTitle: 'Multimedia Messaging Service (MMS)',
    messaging: 'Messaging',
    enableMMSModalHeader: 'Enable MMS',
    cancelEnableMMS: 'Cancel enabling MMS',
    proceedEnableMMS: 'Proceed to enable MMS',
    source: 'irl',
    serviceLocations: 'Service locations',
    viewAllService: 'View all services',
    reportAnError: 'Report an error',
    availableTools: 'Available tools',
    serviceTypes: 'Service types',
    productNames: 'Product Names',
    dashboardTileNetworksAndInternet: 'Networks and internet',
    dashboardTileUnifiedCommunication: 'Unified communication',
    filter: 'Filter',
    editFilter: 'Edit Filter',
    currentPlan: 'Current plan',
    AvailablePlans: 'Select available plans based on your current plan',
    ServiceTerm: 'Service Terms',
    deliveryContactFirstName: 'Delivery contact given name/s',
    deliveryContactLastName: 'Delivery contact family name',
    deliveryContactMobileNumber: 'Delivery contact mobile number',
    deliveryContactEmailField: 'Delivery contact email address',
    multipleSharedAPNs: 'Shared APN/s',
    multipleDedicatedAPNs: 'Dedicated APN/s',
    serviceNumber: 'Service Number',
    mobileNumber: 'Mobile number',
    existingPlanType: 'Existing plan type:',
    existingPlan: 'Existing plan:',
    sharedApn: 'Shared APN',
    associatedSharedApn: 'Associated Shared APN',
    selectedSharedApn: 'Selected Shared APN',
    removeSharedApn: 'Remove Shared APN',
    dedicatedApn: 'Dedicated APN',
    associatedDedicatedApn: 'Associated Dedicated APN',
    selectedDedicatedApn: 'Selected Dedicated APN',
    removeDedicatedApn: 'Remove Dedicated APN',
    existingPlanTypeForPayload: 'Existing Plan Type',
    existingPlanForPayload: 'Existing Plan',
    pmInsightMetricHeader: 'Upcoming planned maintenance',
    plannedMaintenance: 'Planned maintenance',
    networkPerformanceReports: 'Network and Performance reports',
    sdWan: 'SD-WAN',
    secureEdgeNetwork: 'SecureEdge',
    internetProductDetails: 'Internet product request',
    requestNo: "Request No",
    strategic: 'strategic',
    crmSource: 'VLOCITY',
    assetIdentifier: 'vlocity'
};

export const messages = {
    tryAgain: 'try again',
    tryAgainText: 'Please try again',
    customCatalogueAssistiveText: 'Enter at least three alphanumeric characters to start the search starting with 614.',
    mobileNoAssistiveText: 'Start the search with 614.',
    mobileNoAssistiveTextNoStop: 'Start the search with 614',
    deliveryContactAssistiveText: 'The name of the person who will receive the delivery. Or you can' +
        ' add a job role if a specific person’s name is not known e.g. building receptionist, security guard.',
    emailAssistiveTextforDeliveryContact: 'This may be used to contact the person receiving the delivery.',
    deliveryContactEmailAssistiveText: 'This email may be used to contact the person receiving the delivery',
    deliveryContactNumberAssistiveText: 'This number may be used to contact the person receiving the delivery',
    validateDeliveryAddressError: ['Sorry we cannot verify your address.' +
        ' Please use another delivery address or submit support enquiry.',
    ' Sorry we cannot verify your address. Please use another delivery address or call 1800 370 430.'],
    staffTooltip: 'Telstra staff cannot make this change.',
    staffAttachmentTooltip: 'Telstra staff cannot download attachment',
    optionSelect: 'Select an option',
    emptyCreatedDate: 'Not available',
    emptyStatus: 'Not available',
    emptyTargetDueDate: 'To be confirmed',
    errorCreateRequest: 'An error occurred while trying to create the Service Request',
    paginationErrorOccur: 'Error occurred while loading more content',
    paginationTryAgain: 'Try again in a few moments',
    noRequestsListItem: 'There are currently no service requests',
    equestErrorStub: 'Error occurred while loading screen',
    cancelRequest: 'Do you want to cancel this request?',
    creationRequest: `We'll get back to you shortly.`,
    addCustomerReferenceLink: 'In meantime you can',
    createRequestLink: 'Use the request ID link above to check on the progress of your request.',
    raiseSupportEnquiry: 'To request the removal of suspension placed on this service by Telstra,' +
        ' please submit a support enquiry.',
    submittedIrMonthPassNote: 'Note: This does not enable or disable International Roaming.' +
        ' To do either of these, select \'Enable/disable International Roaming\' on a new request below.',
    anotherRequest: 'New request',
    anotherNewRequest: 'new request',
    viewRequest: 'View all requests',
    comingSoon: `We're working on something new.`,
    errorCategoryList: 'Error occurred while loading categories list',
    errorCategoryItem: 'Error occurred while loading category items',
    errorQuestionList: 'Error occurred while loading questions list',
    categoryQuestionTexts: 'Please select the category your request best relates to',
    categoryItemQuestionText: 'What type of request would you like to create?',
    productGroupTitle: 'Product or service type',
    incompleteStepPrompt: 'Please select a Service request category',
    manadateFields: 'Please fill in all the required fields',
    leastCharacters: 'Enter at least 3 characters to start the search',
    requiredField: 'This field is required',
    fieldRequired: 'Required field.',
    samePlanSelected: 'You are already on this plan. Please select another plan.',
    invalidEmail: 'Not a valid email address',
    invalidEndDate: 'End date cannot be before the start date',
    suspendServiceError: 'You cannot suspend a service you have already suspended.',
    resumeServiceError: 'You cannot resume an already active service.',
    suspendedByTelstraForResume: ['This service has been suspended by Telstra.' +
        ' To resume this service please submit a support enquiry.',
    'This service has been suspended by Telstra.' +
    ' To resume please call 1800 370 430.'],
    suspendedByBothForResume: ['If required, you can remove' +
        ' the suspension placed on this service by Telstra after submitting this form.' +
        ' We\'ll provide you with a link to submit a support enquiry.', 'If required, ' +
        'you can remove the suspension placed on this service by Telstra after submitting this form. ' +
    'Please call 1800 370 430.'],
    suspendedByTelstraMessageForSuspend: 'This service has already been suspended by Telstra.' +
        ' You can place an additional suspension on-top of this if it lost or stolen. ',
    mobileNumberAssistiveText: 'Start the search with 614.',
    noActivities: 'Thanks for your request. We’re working on it now and will add updates here soon.',
    emptyList: 'There is nothing to show',
    comingSoonSubHead: `We're working on`,
    comingSoonSubPart: 'something new.',
    errorIndicator: 'There was an error loading this app.',
    dropdownError: 'Something went wrong.',
    dropdownNoResult: 'There are no results.',
    mobileDropdownNoSearchText: 'Start typing 614 then select the relevant number.',
    tonMobileDropdownNoSearchText: 'Start the mobile number search with 614.',
    deliveryAddressDropdownNoSearchText: 'Start typing then select a delivery address.',
    apiCallError: 'Oops – something went wrong. Try again.',
    requestCreated: 'Service Request created successfully',
    statusChange: 'Status has changed to ',
    postCommentError: 'Your reply was not posted due to server error. Please try again.',
    bannerMessage: 'This is a read-only version of requests. ' +
        'If you need to upgrade your access so you can create and edit requests, ' +
        'contact your Telstra representative.',
    deviceListTable: 'deviceListTable',
    topTenAppsListTable: 'topTenAppsListTable',
    serverError: 'Server error',
    pending: 'Pending',
    enrolled: 'Enrolled',
    noOrderCreated: 'No order created',
    noDataAvailable: 'No data available',
    noDataEnrolled: 'No data available, enroled < 24 hours',
    noPlanAvailable: 'This device is not on an eligible Telstra plan',
    mdmErrMsg: 'There were some errors trying to load your devices information, please refresh the page to',
    maximRequestListPreText: 'You\'ll soon be able to see a list of any of the product',
    maximRequestListPostText: 'or service changes you\'ve requested. Stay tuned.',
    voicemailError: 'Something went wrong.',
    // linkToYPS: GetDisplayName(ApplicationName),
    invalidEmailAddress: 'Invalid email address',
    invalidPhoneNumber: 'Invalid mobile number',
    invalidContactNumber: 'Phone numbers can only use +, spacing and numbers',
    invalidContactName: 'Use alphanumeric characters and basic punctuation (‘ . , $ % !) only.',
    textAreaLimitForMaxim: 'Maximum 1000 characters',
    manageServicesMessage: `To make changes to a mobile service(s), select from the menu options under 'Manage' ` +
        `at right below. For other requests, select 'New request' below. We're making regular updates to this screen, `
        + `so keep an eye out for new features.`,
    adaptiveMobilitymanageServicesMessage: `To make changes to a mobile service(s), select from the menu
    options under ‘Manage’ at right below. We’re making regular updates to this screen, so keep an eye out
    for new features. For all Adaptive Mobility or Corporate Mobile Plus services, select ‘Manage’ below.`,
    noMobileServices: 'There are currently no mobile services',
    customReferenceInputText: `Enter at least three alphanumeric characters to start the search. ` +
        `Depending on the detail required, this could be a mobile number (starting with 614), ` +
        `an IMEI (15 numbers) or an address`,
    fncLandingPageDescription: `Feature Network Change requests are acted on faster than service requests
    (usually 1-3 business days) for a fee. If the service you're looking for isn't listed below, you can use the `,
    fncFormPageDescription: `Feature Network Change requests are acted on faster than
    service requests (usually 1-3 business days) for a fee.`,
    fncPriceDescription: `There is a minimum charge of $110 including GST for this change, plus any recurring charges
    that may result. Changes to be made as soon as possible are typically completed within 1-3 business days. Changes
    that you need made after business hours will be charged more. Business hours are Monday to Friday 8am to 5pm
    (excluding public holidays) in the time zone of your site in Australia where the equipment is located.`,
    trackFncRequest: 'Use the change ID link above to track the progress of your change.',
    viewAllFnc: 'View all Feature Network Changes',
    viewAllServiceRequests: 'View all Service Request',
    dashboard: 'Dashboard',
    ypsLandingPageMessage: 'We\'re working on letting you manage more of your products' +
        ' and services in Telstra Connect – stay tuned!',
    YTTMessageOnYPSLandingPage: 'To manage bills, track calls and buy data packs go to ',
    TelstraPartnerMessageOnYPSLandingPage: 'If your services are managed through a Telstra partner, ' +
        'please contact them to submit your request.',
    noNbnServiceMessage: 'To learn more about our nbn products and services, contact your Telstra representative.',
    loopbackTest: 'Checks the network connectivity between your nbn device and its gateway into our network.',
    portResetTest: 'Resets the DSL port on the nbn device that connects to your modem to help resolve data' +
        'flow and syncing issues.',
    NTDreset: `If you're experiencing degradation, intermittent or partial loss of your nbn service, an
                NTD (network terminating device) reset can resynchronise your nbn connection device.` ,
    errorCreateFncRequest: 'An error occurred while trying to create this request.',
    attachmentHelptext: `File types supported include .jpg, .jpeg, .png, .gif, .csv, .xls, .xlsx, .doc, .docx, .pdf, ` +
        `.txt, .bmp, .ods, .xlsm and maximum of 5 files with total size limit of 3.4MB`,
    updateNoteTextOfSRForms: `Note: Please do not upload personal information (e.g. PINs, passwords, dates of birth), credit/` +
        `debit card or bank account details, or other sensitive content that you do not want us and` +
        ` others in your organisation (with Telstra Connect access) to see.`,
    submitBug: 'submit a bug',
    errorPersist: 'If this error persists please ',
    ypsRequestCatalogueMessage: 'Raise service requests to manage your products'
        + ' and services that are currently available in Telstra Connect.',
    fncRequestThroughYPSCataloguePage: 'For a faster response (usually 1-3 business days) you can raise a ',
    nbnIntroductionOne: `You can check your nbn connectivity or request the following two resets as a part
    of your nbn testing and troubleshooting.`,
    nbnIntroductionTwo: `A test/reset can take up to two minutes to run and may pause or degrade your service in that
    time. We recommend running a test/reset outside of your operating hours or during a less busy time.`,
    nbnIntroductionThree: `We'll notify you here when the nbn results are returned. Please don't refresh the page.`,
    nbnBannerDescription: `You will soon be able to request multiple tests at a time - we're working on it.`,
    selectServiceMsg: `Select a service ID you'd like to run a `,
    multipleSelectServiceMsg: `Select the Service ID(s) you'd like to run a `,
    selectedServiceMsg: `You've selected 1 Service ID to run a `,
    multipleSelectedMsg: `You've selected `,
    serviceIDs: ` Service ID(s) to run a `,
    multipleBannerDescription: `You can run a maximum of 5 `,
    oneTime: `s at one time`,
    on: ' on',
    comingSoonMsg: `Coming soon: Test and reset options for more of our nbn services,
                     including Connect IP and Business IP.`,
    attachmentFootnote: `Upload any images or files that you believe may be helpful in solving this issue
                including screen shots of error messages and testing results.`,
    testInProgress: ' in progress for service ID ',
    updateMsg: `. Don't refresh the page.`,
    serviceID: ' service ID        ',
    testSuccess: ' passed for service ID ',
    testFailed: ' failed for service ID ',
    uploadFailed: 'Upload failed. Please try again.',
    refreshMsg: `Don't refresh.`,
    fncRequestsPageDescription: `Showing Feature Network Changes that are active or have
    been completed in the last 45 days`,
    testIncomplete: `Couldn't complete `,
    testComplete: ' complete for service ID ',
    invalidFNN: 'Invalid number. Please try again.',
    nbnNoHistoryMsg: 'No recent test results to display',
    nbnNoHistoryResult: `After you run a test for this service ID you'll see it here.`,
    simSerialAssistiveText: `A new blank SIM is required. You cannot use
     the SIM serial number previously associated with this mobile number.`,
    activateNewServiceDefaultAlertText: `This number may not be available to activate. After you submit this request
     our team will contact you within one business day to confirm if this number can be activated again.`,
    activateNewServiceSecondFLowAlertText: `Choose a current active mobile number and we will apply the same
     plan and settings to your new mobile number.`,
    adaptiveMobilityTooltipText: `Services include:

        Adaptive Mobility

        - Mobile Essential, Enhance and Epic

        - Mobile Broadband Essential,
         Enhanced and Epic

        - Enterprise Wireless Epic

        Corporate Mobile Plus

        Mobile and Broadband Local, National
        and Global plans with the option to
        BYO devices from us.`,
    reactivatePassDueDateInformation:
        ' has been deactivated for more than 28 days. Please choose one of the following options to proceed:',
    reactivatePassDueDateDefaultFirstRadioOption: 'Request to activate a new service using mobile number',
    reactivatePassDueDateDefaultSecondRadioOption: 'New mobile number',
    reactivatePassDueDateSearchQuestionText: 'Search for an active mobile number',
    reactivatePassDueDatetableQuestionText: 'Select a mobile number to apply the same plan and settings to',
    reactivatePassDueDateNoResultFoundFirstMessage: 'No results found.',
    reactivatePassDueDateNoResultFoundSecondMessage: 'Please search for an active number.',
    reactivatePassDueDateFirstQuestionHeader: (mobileNumber) => `${mobileNumber} details`,
    reactivatePassDueDateSecondQuestionHeader:
        'We may need to contact you about this request. If so, who should we connect?',
    reactivatePassDueDateSimSerialInputPlaceholder: 'Should contain 13 numbers',
    tempSuspensionDiversionNumberText: `Invalid entry. Mobile number must begin with '04' and be 10 digits.`,
    alertTextForMobileServiceDetailPage: `Changes made to this mobile
     service can take up to 24 hours to be updated on this screen.`,
    alertTextForMigratedMobileServiceDetailPage: `This mobile service was recently migrated to our new
     Adaptive Mobility network. More details for this service are available under
      Billing and Networks and internet. `,
    alertTextForMigratedMobileServiceDetailPageNewLine: `Changes made to this mobile service can
     take up to 24 hours to be updated on this screen.`,
    reactivatePasssDueDateValidationErrorOnSearch: (text: string) =>
        `Please ${text} for an active mobile number to continue`,
    reactivatePassDueDateMoreResultFoundFirstMessage: (countOfServices: string) =>
        `${countOfServices} search results found, which is too many. Please refine your search.`,
    nbnHistoryDescription: 'Your test results from the past 20 days.',
    noSearchMsg: 'No items match your search',
    trySearchAgain: 'Try again with another search reference',
    historyError: 'Error - please try again',
    reportErrorMsg: 'If that does not fix it, please report this error.',
    fncTooltipDescription: 'One file (uncompressed) can be uploaded with a maximum file size of 3MB.',
    fncNoRecordsMessage: `You don't have any requests to track`,
    fncTrackRequestMessage: 'Once you start submitting requests you can track them here.',
    infoMessageForSupportEnquiryNavigationaPage: `By selecting continue you will be taken to a support enquiry
        form which will engage our Telstra support team to assist with your request.`,
    infoMessageForNewEnquiryNavigationaPage: `By selecting continue you will be taken to our
    support page to complete your enquiry.`,
    fncInvalidFieldLength: (minimumLength: number) =>
        `Invalid length. Minimum ${minimumLength} characters required.`,
    tempSuspensionAlertMessageText: `The device's IMEI will not be blocked while its number is
     suspended. Any new SIMs for this mobile service will not be sent while it is suspended`,
    tempSuspSubheaderInfoText: `Once the service is reactivated the call diversion you set up
     now will be removed and any existing call diverting will be restored.`,
    tempSuspInputBoxHeader: `Enter mobile number (optional)`,
    tempSuspDiversionHeader: `Forward calls to the following number while this mobile number is suspended:`,
    backToDetailPage: (serviceNumber: string) => `Back to ${serviceNumber}`,
    tempSuspToastMessage: 'Your temporary suspension request has been submitted.',
    deacToastMessage: 'Your deactivation request has been submitted.',
    invalidStreetNumber: 'Not a Valid street number',
    resumeService: 'Found your phone? Submit this form to get your mobile service back up ' +
        'and running after it was suspended.',
    activeService: 'You cannot resume an already active service.',
    inactiveService: 'You cannot resume an inactive service.',
    pendingActivationService: 'You cannot resume a service which is pending activation.',
    activeEmptyServieReference: 'No reference applied. Create a request to add one.',
    nonActiveEmptyServiceReference: 'No reference applied when service was last active.',
    resumeActiveServiceError: 'You cannot resume an already active service.',
    resumeInactiveServiceError: 'You cannot resume an inactive service.',
    resumePendingActivationServiceError: 'You cannot resume a service pending activation.',
    suspendInactiveServiceError: 'You cannot suspend an inactive service.',
    suspendPendingActivationServiceError: 'You cannot suspend a service pending activation.',
    yourServiceReferenceTooltipText: 'Your reference, for your records. ' +
        'This reference will also display on invoices and elsewhere on Telstra Connect.',
    somethingWentWrong: 'Something went wrong!',
    selectSharedAPN: 'Select a shared APN',
    sharedAPN: 'Shared APN',
    dedicatedAPN: 'Dedicated APN',
    selectDedicatedAPN: 'Select a dedicated APN',
    tnSourceIntroText: 'To request a bulk APN change to a set of your organisation’s mobile devices' +
        'contact us on 1800 370 430.',
    requiredSharedAPNField: 'You need to select which shared APN you want to use',
    requiredDedicatedAPNField: 'You need to select which dedicated APN you want to use',
    tnAPNFooterText1: 'There may be charge associated with selecting, changing or removing an APN. View our ',
    tnAPNFooterText2: ' for details.',
    supportEnquiry: 'support enquiry',
    serviceTems: 'service terms',
    tnMultipleAPNTitle: 'Select or remove Access Point Name/s (APN/s)',
    tnMultipleAPNKey:  '9a103512db361050beee52e344961937',
    noSharedAPNs: 'No shared APN/s are available',
    noDedicatedAPNs: 'No dedicated APN/s are available',
    heavyLifting: 'heavy_lifting',
    workFromHeight: 'work_from_height',
    hotWork: 'hot_work',
    visitorDetails: 'Visitor Details',
    removalComany: 'Removal Company Details',
    deliverRequest: 'Delivery Details',
    dataCentreAccessRequest: '5fd1b2aedb690784729973e9bf961930',
    equipmentRemoval: '30c47e22dba90784729973e9bf9619c3',
    remoteHandsRequest: '68bfeeaadb690784729973e9bf96191e',
    deliveryRequest: 'bd25991cdb354fc4729973e9bf9619e8',
    tnEnableIRMonthPassTitle: 'Enable/disable International Roaming Month Pass',
    tnAcceleratorAddOnTitle: 'Enable / disable Accelerator add-on',
    tnManageDirectoryListingTitle: 'Manage directory listing',
    tnTONKey: 'e03780781b277c10e9d8c91d0d4bcb0e',
    tnDeactiveMSKey: '8c4f9305dbf10090e571da857a9619f3',
    tnHardwarePayoutKey: 'c4c3cf54dbe18c10e571da857a9619d6',
    tnChangeAdaptiveMobilityKey: '6a225461db861c50d4002db614961967',
    tnChangeAdaptiveMobilityVoicemailKey: '38d80de21bc79410ae4b31ddcc4bcb81',
    tnEnableIRMonthPassKey: '795fc59ddbc39c50beee52e34496191c',
    tnInternationalDirectDialKey: '60a57826db031490beee52e3449619e4',
    tnAcceleratorAddOnKey: '0d388552dbc3ec50beee52e3449619b6',
    tnManageDirectoryListingKey: 'aad2febddbcd5950beee52e344961932',
    iddToolTip: 'If you are enabling international calls with international roaming disabled,' +
        'you will need to enable international roaming if you are going overseas.',
    mobileServiceintRoamVisibleAlertMessage: 'You will need to enable to make calls and use data while overseas',
    mobileServiceintRoamHiddenAlertMessage: ' about inclusions, eligible countries and charges',
    mobileServiceintRoamEnabledAlertMessage:
        'To make calls while overseas, please ensure international calls are also enabled before leaving Australia.',
    mobileServiceintRoamEnabledAlertMessageWithCalling: ' See \'Calling\' below.',
    leavingTConnectPageModalMessage: 'Your Telstra Connect session times out after 15 minutes of no activity,' +
        'so if you\'re gone for a while you will need to sign back in.',
    intRoamLinkURL: 'https://www.telstra.com.au/support/mobiles-devices/international-roaming',
    serviceTermsUrl: 'https://www.telstra.com.au/customer-terms/digitalterms',
    supportEnquiryUrl: 'https://connectapp.telstra.com/app/customer-support/new-enquiry',
    customertermsLinkURL: 'https://www.telstra.com.au/customer-terms/business-government#telstra-mobile',
    irMonthPassServiceTermsUrl: 'https://www.telstra.com.au/content/dam/tcom/personal/consumer-advice/pdf/' +
        'consumer/adaptive-mobility-dsa-service-terms.pdf',
    disableIntRoamModalDescription:
        'If you also have international calls enabled, please disable them under ‘Calling’.',
    modalServerError: 'The server was unable to complete your request.' +
        ' Please try again. If that does not fix it, please report this error.',
    intRoamSubmissionSuccessToastMessage: 'Your international roaming request has been submitted.',
    strategicDeviceDetailsBanner: 'We\'re working on some updates to this screen.'
        + 'More settings and functionality are coming soon. ',
    iddDisablePending: 'Pending disabling international calls',
    iddEnablePending: 'Pending enabling international calls',
    iddEnableAdaptivePending: 'Pending enabling international calls for adaptive mobility',
    iddAdaptiveInfo1: 'This pack will only help while in Australia to make international calls.',
    iddAdaptiveInfo2: 'This pack will not help while overseas without international roaming enabled.',
    iddSuccessMsg: 'Your international calling request has been submitted',
    iddNonEligibleText: 'This is a data-only plan. If you\'d like to add International calling, ' +
        'you\'ll need to upgrade to a voice and data plan.',
    serviceStatusDiscrepancy: 'It looks like this service has been changed in the last 24 hours' +
        'e.g. it might have been deactivated or suspended.' +
        '\n The new Early Termination Charge can take up to 24 hours to display.' + '\n Please try again later.',
    apnSuccessMsg: 'Your APN request has been submitted',
    mmsSuccessMsg: 'Your MMS request has been submitted',
    voicemailSuccessMsg: 'Your voicemail request has been submitted',
    changeVoiceMailSuccessMsg: (voicemailType) => `Your request to change your voicemail to ${voicemailType}
     has been submitted`,
    apnGenericAlertMsg: 'This may not be the full list of available APN',
    apnAssistiveText: 'The network path for data connectivity',
    loadingError: 'Loading error',
    apnActiveDefault: 'Activate a default APN to access data',
    apnPendingAdding: 'Pending - Adding APN/s',
    apnPendingRemoving: 'Pending - Removing APN/s',
    apnRadioButtonSelectionErrorMessage: 'You must select an option to continue',
    removeAPN: 'Remove APN',
    sameApnSelectionError: 'You are currently using this APN. Please select a different' +
        ' APN or to remove the current APN.',
    currentApnText: ' - Current APN         ',
    removeAPNWarning: 'Removing this APN may leave this service without some or all access to data-driven features.',
    submissionSuccessToastMessage: (serviceNumber: string) => `Your request for ${serviceNumber} will be updated
     under its status below in the next few minutes.`,
    mmsPendingEnabling: 'Pending - Enabling MMS',
    mmsPendingDisabling: 'Pending - Disabling MMS',
    mmsNotEligibleAlertMsg: 'This is a data-only plan. If you\'d like to add MMS, ' +
        'you\'ll need to upgrade to a voice and data plan.',
    serviceLocationToolTip: `Highlighted locations represent where performance data has been available within the
    last 30 days. These locations also show the performance health based on the last polled event.`,
    noDataAvailableNITMore: `We currently only provide network performance reporting for our Integrated Operations
    Management (IOM) and IPVPN products. If you have either of these services and they are not displaying,
    please let us know.`,
    noDataAvailableNITLess: `We currently only provide network performance reporting for our Integrated Operations
    Management (IOM) and IPVPN products.`,
    apiErrorDescription: 'If this problem persists you can report an error',
    serviceTypeToolTip: 'Only displays service types with polling data captured within the last 30 days.',
    productNameToolTip: 'Only displays product names with polling data captured within the last 30 days.',
    voicemailNotEligibleAlertMsg: `This is a data-only plan. If you'd like to add MessageBank®,
    you'll need to upgrade to a voice and data plan.`,
    movedTimeZone: 'Moved to a different time zone? (Optional)?',
    movedTimeZoneDesc: 'Change it here to make sure you get your local time stamp with messages.',
    noChangesToSave: 'No changes has been made to save',
    mobileOthersMaximText: `Showing mobility solution requests that are active or have been
    completed in the last 45 days.`,
    selectCompanyText: 'Select your prefered company view.',
    etcToolTip: `If today you wish to deactivate this service or pay out a
     product associated with it that is subject to an ETC, you will be charged the total estimate displayed.`,
    voicemailPending: {
        enablemessageBank: 'Pending - Enabling MessageBank®',
        enablevideoMessageBank: 'Pending - Enabling Video MessageBank®',
        enablemessageBankPlus: 'Pending - Enabling MessageBank® Plus for iPhone',
        enablevoice2Text: 'Pending - Enabling Voice2Text',
        disablemessageBank: 'Pending - Disabling MessageBank®',
        disablevideoMessageBank: 'Pending - Disabling Video MessageBank®',
        disablemessageBankPlus: 'Pending - Disabling MessageBank® Plus for iPhone',
        disablevoice2Text: 'Pending - Disabling Voice2Text',
        ringTime: 'Pending - Changing ring time',
        serviceArea: 'Pending - Changing mobile service area'
    },
    messageBankPlusBannerMsg: 'This option is for iPhones only',
    ypsFilterText: 'Search and select Company name’s',
    deactivateEMService: 'Early Termination Charge',
    noETCText: 'This item has no Early Termination Charge.',
    vlcText: 'You will have to go to service page to deactivate this service.',
    etcError: 'Something went wrong',
    mobileCatalogueModifiedText: 'Start the search starting with 614',
    mobileCatalogueModifiedNoSearchText: `Enter at least three alphanumeric
     characters to start the search starting with 614.`,
    deliveryContactFirstNameAssistiveText: 'The first name/s (or the name they go by) of the person who will receive the delivery.',
    deliveryContactLastNameAssistiveText: 'The family/last name of the person who will receive the delivery.',
    deliveryContactMobileNumberAssistiveText: `Enter the number starting with 04 or +614. No spaces.`,
    invalidLength: 'Invalid length. Email address exceeds the 64-character limit.',
    minCharLength: `Invalid length. Name must have at least two characters.`,
    fnMaxCharLength: `Invalid length. Given name/s exceeds the 40-character limit.`,
    lnMaxCharLength: `Invalid length. Family name exceeds the 50-character limit. `,
    invalidEntry: `Invalid entry. Use only letters, hyphens(-) and apostrophes(').`,
    spaceBeforeName: `Invalid entry. Name cannot have a space before the first letter.`,
    reservedName: `Invalid entry. Name cannot include titles, acronyms, business terms or 
    other terms not typically associated with a person's name.`,
    invalidPhonePattern: 'Invalid number. The mobile number must start with +614.',
    invalidPhoneCharacters: 'Invalid number. Use only numbers and +.',
    invalidPhoneLength: 'Invalid length. The mobile number must conatin 12 characters, including the +614 prefix.',
    invalidEmailPattern: 'Invalid email. Only use alphanumeric characters, @, dots(,), underscores(_) and hyphens(-).',
    sharedApnsIntro: 'A shared APN is a mobile network gateway that is shared with other customers.',
    sharedApnsSelectionIntro: 'Select up to five shared APNs',
    dedicatedApnsIntro: 'A dedicated APN is an exclusive mobile network gateway' +
        ' (not shared with other customers).',
    dedicatedApnsSelectionIntro: 'Select up to five dedicated APNs',
    apnsSelectionAlert: 'To add a different APN, remove one of your selections.',
    consentText: `I consent to sharing the details of the attachment/s with Telstra agents
    and others in my organisation with Telstra Connect access.`,
    consentTextAble: 'By submitting this request, I consent to sharing the details of this request and its attachment/s' +
    'with Telstra agents and others in my organisation with Telstra Connect access.',
    govIDTextStart: 'Only enter the first five characters.',
    govIDTextEnd: "Only enter the last five characters",
    consentNote: `Note: Please do not upload personal or sensitive information that
    you do not want Telstra agents and others in your
    organisation (with Telstra Connect access) to see.`,
    deactivateWithEtcErrorMsg1: 'An error occurred while fetching the charges.',
    deactivateWithEtcErrorMsg2: 'If you click submit now, the early termination charges will still apply,',
    deactivateWithEtcErrorMsg3: `even if you haven't seen them here.`,
    deactivateWithEtcErrorMsg: `An error occurred while fetching the charges. <br /> <br />
                If you click submit now, the early termination charges will still apply, even if you haven't seen them here.`
};

export const mobileServicesDetailPageSIMSerialMessages = {
    assistiveText: 'Enter 13-digit serial number. Must start with 7, 8 or 9.',
    lessThanThirteenInput: '13 digits required.',
    sameSIMSerialNumberInput: 'Please enter a different SIM serial to the existing one.',
    inputOtherThanRequriedStartingNumber: 'Serial number must start with 7, 8 or 9.',
    requestInProgressInfoMessage: 'Select refresh for any status updates',
    simSerialRedirectionModalContent: 'If you continue, you\'ll lose your changes',
    simSerialRedirectionModalHeader: 'You\'re about to go to a new screen',
    simSerialRequestSubmittedToastContent: 'Your SIM replacement request will take up to one business day to be updated'
}

export const temporarySuspensionWithNoDiversionModalMessages = {
    header: 'Temporarily suspend - No diversion',
    noNumberProvided: 'You have not provided a number to divert all calls to while this service is suspended.',
    costDetails: 'If you choose to set up a call diversion within the next 28 days, it will restart your temporary' +
        ' suspension period. You will be charged $5.50* per month or part thereof for the time your service' +
        ' has already been suspended plus – from the day you add a call diversion number' +
        ' – a further $5.50* per month or part thereof.',
    conditions: '*Includes GST'
}
export const enableIntRoamModalMessages = {
    needToMakeCalls: `Need to make calls while overseas? When international roaming is enabled, you will need to
     ensure international calls are also enabled on this mobile before leaving Australia.`,
    enablingIntRoam: `Enabling international calls removes any call barring that might be in place.`,
    dataUsageOverseas: `If you are concerned about high data usage while overseas, turn off mobile data roaming
     via the settings on the mobile device. This will override any mobile data roaming settings.`,
    enableIntRoamRadioOptionsHeader: 'What would you like to do?',
    enableIntRoamRadioFastChange: 'Activate international roaming on the current mobile service plan,' +
        'which may include pay-as-you-go call and data rates.',
    enableIntRoamRadioMaxim: 'To save on roaming costs, we can help you with the right international roaming pass.',
    intRoamCheckboxText: 'I have read and understood all of the above and agree to enable international roaming.',
    stpGeneralAlertMessage: 'If you need to make calls while overseas, please ensure' +
        ' international calls are enabled before leaving Australia.',
    radioButtonSelectionErrorMessage: 'You must select an option to continue',
    userAgreementCheckErrorMessage: 'You must agree to this to continue'
}

export const enableMMSModalMessages = {
    descHeader: 'MMS requires data and data barring to be removed',
    desc1: `For MMS to work, this service needs data access. If this service is not on a plan,
    pay-as-you-go data rates may apply.`,
    desc2: `If data barring is enabled on this service, we will remove it so that MMS can work.`,
    desc3: `To curb high mobile data usage, turn off mobile data in the phone's settings.`,
    radioOptionsHeader: 'What would you like to do?',
    radioButtonSelectionErrorMessage: 'You must select an option to continue',
    enableRadioFastChange: 'Enable MMS and remove any data barring',
    enableRadioMaxim: 'Enable MMS, remove any data barring and request help with mobile or data plan options',
    stpGeneralAlertMessage: `Before proceeding with the change, remember: If this service is not on a plan,
    pay-as-you-go data changes may apply.`,
    agreementCheckboxText: `I agree to data being used for this service and any pay-as-you-go charges that may occur.`,
    userAgreementCheckErrorMessage: 'You must agree to this to continue',
    questionsHeader: `Leave your details below and we'll contact you about mobile or data plan options.`,
}

export const modifyDiversionModalMessages = {
    header: 'Add or change call forwarding to the temporarily suspended service',
    intro: 'This will restart your 28-day temporary suspension on this service.',
    costDetails: 'To retain your number you\'ll be charged $5.50* per month or part thereof plus $5.50* pro rata'
        + ' for the time your service has already been suspended.',
    subText: 'If this service is reactivated, the call forwarding you set up now will also be removed and any'
        + ' pre-suspension settings will be restored.',
    conditions: '*Includes GST'
}
export const allowedTNOWFileFormats = ['.asc', '.bmp', '.csv', '.doc', '.docx', '.eml',
    '.gif', '.htm', '.html', '.ics', '.jpeg', '.jpg', '.jpgx', '.mc', '.mht', '.mp3', '.ms', '.msg',
    '.odg', '.odp', '.ods', '.odt', '.oft', '.p7s', '.pdf', '.png', '.pngx', '.ppt',
    '.raw', '.rtf', '.tif', '.tiff', '.txt', '.url', '.vsd', '.vsdx', '.wav', '.wmv', '.xls', '.xlsb',
    '.xlsm', '.xlsx', '.xml', '.xps', '.zip', '.gifx', '.image', '.pptx', '.ppts', '.json', '.keystore'];

export const allowedSCFileFormats = ['.asc', '.bmp', '.csv', '.doc', '.docx', '.eml',
    '.gif', '.gifx', '.htm', '.html', '.ics', '.jpeg', '.jpg', '.jpgx', '.mc',
    '.mht', '.mp3', '.ms', '.msg', '.oft', '.p7s', '.pdf', '.png',
    '.pngx', '.pptx', '.rtf', '.tif', '.tiff', '.txt', '.url', '.vsd', '.vsdx',
    '.wav', '.xls', '.xlsb', '.xlsm', '.xlsx', '.xml', '.xps', '.zip', '.ppt',
    '.ppts', '.raw', '.wmv', '.ods', '.odg', '.odp', '.odt', '.json', '.kml'];

export const allowedFncFiles = ['.doc', '.pdf', '.xls', '.docx', '.xlsx', '.jpeg', '.jpg', '.txt', '.bin', '.rtf', '.gif', '.mp3', '.wav', '.zip']

export const filterWords = {
    location: ['not available', '0', 'unknown', 'zzzz', 'zzzz \\(zzz\\)'],
    categoryItem: ['New User Service Connect', 'Online Reporting Portal Access', 'Portal User Access Request',
        'Request access to ATS portal', 'Service Connect Access Request', 'C3 Portal Access']
};

export const externalLinks = {
    nguc: {
        subCategory: 'Telstra Collaboration',
        link: 'https://www.collaboration.telstra.com/',
        value: 'Configure Telstra Collaboration',
        source: 'TN'
    },
    mdm: {
        subCategory: 'Mobile Device Managment',
        link: 'mobile-device-management/device_info',
        value: 'Mobile Device Managment',
        source: 'TN'
    }
};

export const AdaptiveExternalLinks = {
    nguc: {
        subCategory: 'Adaptive Collaboration',
        link: 'https://www.collaboration.telstra.com/',
        value: 'Configure Adaptive Collaboration',
        source: 'TN'
    }
};

export const mdmServices = {
    nothingToShow: 'There is nothing to show',
};

export const mdmObj = {
    key: 'mdmObjd1fec6156fba21008be10b55eb',
    value: 'Mobile Device Managment',
    catItemList: [
        {
            key: 'catItem02b1b3276fb2c200be2ee4021',
            value: 'Manage Mobile Devices',
            mdmLink: 'mobile-device-management/device_info',
        }
    ]
};

export const serviceToolObj = {
    key: 'serviceToolObjd1fec6156fba21008be10b55eb',
    value: 'Service configuration and reporting tools',
    subCategories: [
        {
            key: 'serviceObject1fec6156fba21008be10b55eb',
            value: '',
            catItemList: []
        }
    ]
};
export interface IMobileServicesFastChangeRequestCardData {
    request: IMobileServicesFastChangeRequestCardChildData,
    fastChange: IMobileServicesFastChangeRequestCardChildData,
}
export interface IMobileServicesFastChangeRequestCardChildData {
    id: string,
    header: string,
    p1: string,
    p2: string
}
export const mobileServicesFastChangeRequestCardData = {
    request: {
        id: headerName.reactivateWithinDueDateCatItemKey,
        header: 'Request',
        p1: 'Trackable with reference #',
        p2: 'Takes up to one business day'
    },
    fastChange: {
        id: 'reactivate-fastChange',
        header: 'Fast change',
        p1: 'Not trackable',
        p2: 'Takes up to a few minutes'
    }
}
export const LegislationsFAQUrl = '/app/support/faq'
export const mdmObjCategory = {
    mobilitySolutions: 'Mobility Solutions'
};

export const yourRequestReferenceField = {
    commonQuestions: [
        {
            id: 1,
            questionText: 'Contact name (optional)',
            identifier: 'requestedForName',
            questionFormat: 'Single Line Text',
            isRequired: false,
            isEditable: true,
            stateName: 'contactName'
        },
        {
            id: 2,
            questionText: 'Contact phone number (optional)',
            identifier: 'requestedForPhone',
            questionFormat: 'Single Line Text',
            isRequired: false,
            isEditable: true,
            stateName: 'contactPhoneNumber'
        },
        {
            id: 3,
            questionText: 'Contact email (optional)',
            identifier: 'requestedForEmail',
            questionFormat: 'Single Line Text',
            isRequired: false,
            isEditable: true,
            stateName: 'contactEmail'
        },
        {
            id: 4,
            questionText: 'Your request reference (optional)',
            identifier: 'x10',
            questionFormat: 'Single Line Text',
            isRequired: false,
            isEditable: true,
            maxLength: 20,
            stateName: 'customerReference'
        }
    ]
}
export const reactivatePassDueDateQuestions = {
    commonQuestions: [
        {
            id: 1,
            questionText: 'SIM serial',
            identifier: 'x2',
            questionFormat: 'Single Line Text',
            isRequired: true,
            isEditable: true,
            stateName: 'simSerialInput'
        }
    ],
    mobileNumberDetail: [
        {
            id: 2,
            questionText: 'Mobile number selected',
            identifier: 'x1',
            questionFormat: 'Single Line Text',
            isRequired: true,
            isEditable: false,
            stateName: 'selectedMobileNumber'
        },
        {
            id: 3,
            questionText: 'Username (optional)',
            identifier: 'x3',
            questionFormat: 'Single Line Text',
            isRequired: false,
            isEditable: true,
            stateName: 'userName'
        },
        {
            id: 4,
            questionText: 'Username visible on invoice',
            identifier: 'x4',
            questionFormat: headerName.selectBox,
            isRequired: false,
            isEditable: true,
            stateName: 'isVisibleOnInvoice'
        },
        {
            id: 5,
            questionText: 'Plan',
            identifier: 'x5',
            questionFormat: 'Single Line Text',
            isRequired: true,
            isEditable: false,
            stateName: 'planName'
        },
        {
            id: 6,
            questionText: 'Billing account',
            identifier: 'x6',
            questionFormat: 'Single Line Text',
            isRequired: true,
            isEditable: false,
            stateName: 'billingAccount'
        }
    ],
    customerContactDetails: [
        {
            id: 7,
            questionText: 'Contact name (optional)',
            identifier: 'requestedForName',
            questionFormat: 'Single Line Text',
            isRequired: false,
            isEditable: true,
            stateName: 'contactName'
        },
        {
            id: 8,
            questionText: 'Contact phone number (optional)',
            identifier: 'requestedForPhone',
            questionFormat: 'Single Line Text',
            isRequired: false,
            isEditable: true,
            stateName: 'contactPhoneNumber'
        },
        {
            id: 9,
            questionText: 'Contact email (optional)',
            identifier: 'requestedForEmail',
            questionFormat: 'Single Line Text',
            isRequired: false,
            isEditable: true,
            stateName: 'contactEmail'
        },
        {
            id: 10,
            questionText: 'Your request reference (optional)',
            identifier: 'x10',
            questionFormat: 'Single Line Text',
            isRequired: false,
            isEditable: true,
            maxLength: 20,
            stateName: 'customerReference'
        }
    ]
}

export const createMaximRequestAdditionalAttributes = [
    'Contact name (optional)',
    'Contact phone number (optional)',
    'Contact email (optional)'
]
export const modalName = {
    'Network and Performance reports': 'Network and Performance reports',
    'SecureEdge': 'SecureEdge'
}
export const serviceArray = ['IPVPN', 'GMNS', 'GID', 'IPT', 'GCPE', 'EPL', 'EVPL', 'VPLS', 'IPX', 'ICBS', 'IPL'];

export const strategicCatalogueKeys = [
    headerName.adaptiveMobilitySimReplacementKey,
    headerName.simReplacementKey,
    headerName.resumeMobileServiceKey,
    headerName.suspendMobileServiceKey,
    messages.tnMultipleAPNKey,
    messages.tnTONKey,
    messages.tnDeactiveMSKey,
    messages.tnHardwarePayoutKey,
    messages.tnChangeAdaptiveMobilityKey,
    messages.tnChangeAdaptiveMobilityVoicemailKey,
    messages.tnEnableIRMonthPassKey,
    messages.tnInternationalDirectDialKey,
    messages.tnAcceleratorAddOnKey,
    messages.tnManageDirectoryListingKey
];
export const simCatalogues = [
    headerName.adaptiveMobilitySimReplacementKey,
    headerName.simReplacementKey
];
export const skipAttachmentForCatalogues = [
    'Resume Mobile Service',
    'Suspend Mobile Service',
    'Select or remove Access Point Name/s (APN/s)'
];

export const apnConfirmationModalMessages = {
    header: 'APN charges',
    noApnChangeHeader: 'No APN changes',
    body: 'Submitting this request may change your monthly charges for APN.',
};

export const dynamicCatalogueIntroContent = [
    {
        introTextArray: [`Need to report a lost or stolen phone? Submit this form and we'll suspend ` +
            'the mobile service until further notice.',
        'if you have more than one mobile service to suspend, contact us on 1800 370 430.'],
        catalogueKey: '4a521694db6dcc1052ba147a3a961941'
    },
    {
        introTextArray: ['Found your phone? Submit this form to get your mobile service back up and ' +
            'running after it was suspended.',
        'if you have more than one mobile service to resume, contact us on 1800 370 430.'],
        catalogueKey: '4e7d4714db61005052ba147a3a96193a'
    },
    {
        introTextArray: [
            'An APN is the name of the mobile network that connects a device to a private network or internet. ' +
            'Each device comes with a default public Telstra APN (e.g. telstra.internet, telstra.wap, telstra.mms) ' +
            'and it can be connected to a shared and/or dedicated APN.'
        ],
        catalogueKey: '9a103512db361050beee52e344961937'
    },
    {
        introTextArray: [
            `Subscription to Telstra One Number lets you connect a mobile phone and smart watch to our mobile network.
             This allows the cellular-enabled smart watch to revceive calls, texts and data independently of the phone.
              To be eligible to activate the Telstra One Number subscription,
               you must first unbar the Telstra One Number status.`,
            `The Telstra One Number subscription costs $5.00 inc GST per
             month and is only available for active Telstra mobile numbers.`
        ],
        introTextArrayOld: [
            `Telstra One Number is an add-on subscription that allows mobile end users to pair (Bluetooth)
            their mobile number with a compatible smart watch, so that both devices can connect to our mobile network.
            Users can then use their smart watch to make and receive calls,
            as well as send and receive messages without their phone.`,
            'The Telstra One Number add-on costs $5 per month.'
        ],
        catalogueKey: 'e03780781b277c10e9d8c91d0d4bcb0e'
    },
    {
        catalogueName: 'Pay out hardware item/s',
        introTextArray: [
            `The devices or accessories on a repayment plan that are under agreement are eligible to be paid out.
             By paying out the hardware item, it will be owned outright.`
        ],
        catalogueKey: 'c4c3cf54dbe18c10e571da857a9619d6'
    }
    ,
    {
        catalogueName: 'Change Adaptive Mobility plan',
        introTextArray: [
            `Change current Adaptive Mobility plan to another in the 5G-compatible Mobile, ` +
            `Mobile Broadband and Enterprise Wireless plan range. Any add-ons associated ` +
            `with an existing plan might be carried over to the newly selected plan (please refer to the `
        ],
        catalogueKey: '6a225461db861c50d4002db614961967'
    }
    ,
    {
        introTextArray: ['Request to deactivate an enterprise mobile service/s.'],
        catalogueKey: '8c4f9305dbf10090e571da857a9619f3'
    }
    ,
    {
        catalogueName: 'Change Adaptive Mobility voicemail options',
        introTextArray: [
            `Telstra's standard voicemail service, included with mobile plans, except those using an iPhone.`,
        ],
        catalogueKey: '38d80de21bc79410ae4b31ddcc4bcb81'
    },
    {
        catalogueName: 'Enable/disable International Roaming Month Pass',
        introTextArray: [
            `4GB monthly data allowance with unlimited calls and texts for use in eligible destinations
            (view Service Terms for destination details). The monthly charge applies regardless of roaming usage.`,
        ],
        catalogueKey: '795fc59ddbc39c50beee52e34496191c'
    },
    {
        catalogueName: 'Add, modify or cancel an International Calls and SMS Pack',
        introTextArray: [
            'When added, an International Calls and SMS Pack provides a ' +
            'monthly allowance to make standard voice and video calls and ' +
            'send text messages from eligible Adaptive Mobility plans while ' +
            'in Australia to standard international numbers in eligible destinations:'
        ],
        catalogueKey: '60a57826db031490beee52e3449619e4'
    },
    {
        catalogueName: 'Enable / disable Business Demand Data',
        introTextArray: [
            `Business Demand Data provides reliable, consistent connectivity,
            even when there’s a surge in mobile data traffic.`
        ],
        catalogueKey: '37eae82e1b079410ae4b31ddcc4bcb8f'
    },
    {
        catalogueName: 'Enable / disable Accelerator add-on',
        introTextArray: [
            'The Accelerator add-on provides optimal data speeds and traffic prioritisation in the mobile user’s area.'
        ],
        catalogueKey: '0d388552dbc3ec50beee52e3449619b6'
    },
    {
        catalogueName: 'Manage directory listing',
        introTextArray: [
            'By default, all active mobile services are unlisted (not listed in phone number directories or related services).'
        ],
        catalogueKey: 'aad2febddbcd5950beee52e344961932'
    }
];

export const stateInAddress = [{
    key: 'NSW',
    value: 'NSW'
}, {
    key: 'VIC',
    value: 'VIC'
}, {
    key: 'QLD',
    value: 'QLD'
}, {
    key: 'NT',
    value: 'NT'
}, {
    key: 'SA',
    value: 'SA'
}, {
    key: 'ACT',
    value: 'ACT'
}, {
    key: 'WA',
    value: 'WA'
}, {
    key: 'TAS',
    value: 'TAS'
}
]

export const unitTypeInAddress = [{
    key: 'APARTMENT',
    value: 'APARTMENT'
}, {
    key: 'ATCO',
    value: 'ATCO'
}, {
    key: 'PORTABLE',
    value: 'PORTABLE'
}, {
    key: 'DWELLING',
    value: 'DWELLING'
}, {
    key: 'BARRACKS',
    value: 'BARRACKS'

}, {
    key: 'BUILDING',
    value: 'BUILDING'
}, {
    key: 'CARAVAN',
    value: 'CARAVAN'
}, {
    key: 'CHAMBERS',
    value: 'CHAMBERS'

}, {
    key: 'COMPLEX',
    value: 'COMPLEX'

}, {
    key: 'COTTAGE',
    value: 'COTTAGE'

}, {
    key: 'COUNTER',
    value: 'COUNTER'

}, {
    key: 'DUPLEX',
    value: 'DUPLEX'
}, {
    key: 'FACTORY',
    value: 'FACTORY'
}, {
    key: 'FLAT',
    value: 'FLAT'
}, {
    key: 'GATE',
    value: 'GATE'

}, {
    key: 'HANGAR',
    value: 'HANGAR'

}, {
    key: 'HOUSE',
    value: 'HOUSE'

}, {
    key: 'IGLOO',
    value: 'IGLOO'

}, {
    key: 'JETTY',
    value: 'JETTY'

}, {
    key: 'KIOSK',
    value: 'KIOSK'

}, {
    key: 'LOT',
    value: 'LOT'

}, {
    key: 'MAISONETTE',
    value: 'MAISONETTE'

}, {
    key: 'MARINE',
    value: 'MARINE'

}, {
    key: 'BERTH',
    value: 'BERTH'

}, {
    key: 'OFFICE',
    value: 'OFFICE'

}, {
    key: 'PENTHOUSE',
    value: 'PENTHOUSE'

}, {
    key: 'PIER',
    value: 'PIER'

}, {
    key: 'RESIDENCE',
    value: 'RESIDENCE'

}, {
    key: 'ROOM',
    value: 'ROOM'

}, {
    key: 'SHED',
    value: 'SHED'

}, {
    key: 'SHOP',
    value: 'SHOP'

}, {
    key: 'SITE',
    value: 'SITE'

}, {
    key: 'STALL',
    value: 'STALL'

}, {
    key: 'STUDIO',
    value: 'STUDIO'

}, {
    key: 'SUITE',
    value: 'SUITE'

}, {
    key: 'TOWER',
    value: 'TOWER'

}, {
    key: 'TOWNHOUSE',
    value: 'TOWNHOUSE'

}, {
    key: 'UNIT',
    value: 'UNIT'

}, {
    key: 'VILLA',
    value: 'VILLA'

}, {
    key: 'WARD',
    value: 'WARD'

}, {
    key: 'WAREHOUSE',
    value: 'WAREHOUSE'

}, {
    key: 'WHARF',
    value: 'WHARF'

}

]

export const streetTypeInAddress = [{

    key: 'Access',
    value: 'Access'

}, {

    key: 'Alley',
    value: 'Alley'

}, {
    key: 'Alleyway',
    value: 'Alleyway'

}, {

    key: 'Amble',
    value: 'Amble'

}, {

    key: 'Anchorage',
    value: 'Anchorage'

}, {

    key: 'Approach',
    value: 'Approach'

}, {

    key: 'Arcade',
    value: 'Arcade'

}, {

    key: 'Artery',
    value: 'Artery'

}, {

    key: 'Avenue',
    value: 'Avenue'

}, {

    key: 'Basin',
    value: 'Basin'

}, {

    key: 'Bank',
    value: 'Bank'

}, {

    key: 'Bay',
    value: 'Bay'

}, {

    key: 'Beach',
    value: 'Beach'

}, {

    key: 'Bend',
    value: 'Bend'

}, {

    key: 'Block',
    value: 'Block'

}, {

    key: 'Boundary',
    value: 'Boundary'

}, {

    key: 'Bowl',
    value: 'Bowl'

}, {

    key: 'Boulevard',
    value: 'Boulevard'

}, {

    key: 'Brace',
    value: 'Brace'

}, {

    key: 'Branch',
    value: 'Branch'

}, {

    key: 'Brae',
    value: 'Brae'

}, {

    key: 'Break',
    value: 'Break'

}, {

    key: 'Bridge',
    value: 'Bridge'

}, {

    key: 'Broadway',
    value: 'Broadway'

}, {

    key: 'Brow',
    value: 'Brow'

}, {

    key: 'Bypass',
    value: 'Bypass'

}, {

    key: 'Byway',
    value: 'Byway'

}, {

    key: 'Causeway',
    value: 'Causeway'

}, {

    key: 'Centre',
    value: 'Centre'

}, {

    key: 'Centreway',
    value: 'Centreway'

}, {

    key: 'Chase',
    value: 'Chase'

}, {

    key: 'Circle',
    value: 'Circle'

}, {

    key: 'Circlet',
    value: 'Circlet'

}, {

    key: 'Circuit',
    value: 'Circuit'

}, {

    key: 'Circus',
    value: 'Circus'

}, {

    key: 'Close',
    value: 'Close'

}, {

    key: 'Colonnade',
    value: 'Colonnade'

}, {

    key: 'Common',
    value: 'Common'

}, {

    key: 'Concourse',
    value: 'Concourse'

}, {

    key: 'Copse',
    value: 'Copse'

}, {

    key: 'Corner',
    value: 'Corner'

}, {

    key: 'Corso',
    value: 'Corso'

}, {

    key: 'Court',
    value: 'Court'

}, {

    key: 'Course',
    value: 'Course'

}, {

    key: 'Courtyard',
    value: 'Courtyard'

}, {

    key: 'Cove',
    value: 'Cove'

}, {

    key: 'Crescent',
    value: 'Crescent'

}, {

    key: 'Crest',
    value: 'Crest'

}, {

    key: 'Creek',
    value: 'Creek'

}, {

    key: 'Cross',
    value: 'Cross'

}, {

    key: 'Crossing',
    value: 'Crossing'

}, {

    key: 'Crossroad',
    value: 'Crossroad'

}, {

    key: 'Crossway',
    value: 'Crossway'

}, {

    key: 'Crief',
    value: 'Crief'

}, {

    key: 'Cruiseway',
    value: 'Cruiseway'

}, {

    key: 'Cul-de-sac',
    value: 'Cul-de-sac'

}, {

    key: 'Cutting',
    value: 'Cutting'

}, {

    key: 'Dale',
    value: 'Dale'

}, {

    key: 'Dell',
    value: 'Dell'

}, {

    key: 'Deviation',
    value: 'Deviation'

}, {

    key: 'Dip',
    value: 'Dip'

}, {

    key: 'Distributor',
    value: 'Distributor'

}, {

    key: 'Downs',
    value: 'Downs'

}, {

    key: 'Drive',
    value: 'Drive'

}, {

    key: 'Driveway',
    value: 'Driveway'

}, {

    key: 'Easement',
    value: 'Easement'

}, {

    key: 'Edge',
    value: 'Edge'

}, {

    key: 'Elbow',
    value: 'Elbow'

}, {

    key: 'End',
    value: 'End'

}, {

    key: 'Entrance',
    value: 'Entrance'

}, {

    key: 'Esplanade',
    value: 'Esplanade'

}, {

    key: 'Estate',
    value: 'Estate'

}, {

    key: 'Expressway',
    value: 'Expressway'

}, {

    key: 'Extension',
    value: 'Extension'

}, {

    key: 'Fairway',
    value: 'Fairway'

}, {

    key: 'Fire',
    value: 'Fire'

}, {

    key: 'track',
    value: 'track'

}, {

    key: 'Firetrail',
    value: 'Firetrail'

}, {

    key: 'Flat',
    value: 'Flat'

}, {

    key: 'Follow',
    value: 'Follow'

}, {

    key: 'Footway',
    value: 'Footway'

}, {

    key: 'Foreshore',
    value: 'Foreshore'

}, {

    key: 'Formation',
    value: 'Formation'

}, {

    key: 'Freeway',
    value: 'Freeway'

}, {

    key: 'Front',
    value: 'Front'

}, {

    key: 'Frontage',
    value: 'Frontage'

}, {

    key: 'Gap',
    value: 'Gap'

}, {

    key: 'Garden',
    value: 'Garden'

}, {

    key: 'Gardens',
    value: 'Gardens'

}, {

    key: 'Gate',
    value: 'Gate'

}, {

    key: 'Gateway',
    value: 'Gateway'

}, {

    key: 'Gates',
    value: 'Gates'

}, {

    key: 'Glade',
    value: 'Glade'

}, {

    key: 'Glen',
    value: 'Glen'

}, {

    key: 'Grange',
    value: 'Grange'

}, {

    key: 'Green',
    value: 'Green'

}, {

    key: 'Ground',
    value: 'Ground'

}, {

    key: 'Grove',
    value: 'Grove'

}, {

    key: 'Gully',
    value: 'Gully'

}, {

    key: 'Heath',
    value: 'Heath'

}, {

    key: 'Heights',
    value: 'Heights'

}, {

    key: 'Highroad',
    value: 'Highroad'

}, {

    key: 'Highway',
    value: 'Highway'

}, {

    key: 'Hill',
    value: 'Hill'

}, {

    key: 'Interchange',
    value: 'Interchange'

}, {

    key: 'Intersection',
    value: 'Intersection'

}, {

    key: 'Junction',
    value: 'Junction'

}, {

    key: 'Landing',
    value: 'Landing'

}, {

    key: 'Lane',
    value: 'Lane'

}, {

    key: 'Laneway',
    value: 'Laneway'

}, {

    key: 'Lees',
    value: 'Lees'

}, {

    key: 'Line',
    value: 'Line'

}, {

    key: 'Link',
    value: 'Link'

}, {

    key: 'Little',
    value: 'Little'

}, {

    key: 'Location',
    value: 'Location'

}, {

    key: 'Lookout',
    value: 'Lookout'

}, {

    key: 'Loop',
    value: 'Loop'

}, {

    key: 'Lower',
    value: 'Lower'

}, {

    key: 'Mall',
    value: 'Mall'

}, {

    key: 'Meander',
    value: 'Meander'

}, {

    key: 'Mew',
    value: 'Mew'

}, {

    key: 'Mews',
    value: 'Mews'

}, {

    key: 'Motorway',
    value: 'Motorway'

}, {

    key: 'Mount',
    value: 'Mount'

}, {

    key: 'Nook',
    value: 'Nook'

}, {

    key: 'Outlook',
    value: 'Outlook'

}, {

    key: 'Parade',
    value: 'Parade'

}, {

    key: 'Park',
    value: 'Park'

}, {

    key: 'Parklands',
    value: 'Parklands'

}, {

    key: 'Parkway',
    value: 'Parkway'

}, {

    key: 'Part',
    value: 'Part'

}, {

    key: 'Pass',
    value: 'Pass'

}, {

    key: 'Path',
    value: 'Path'

}, {

    key: 'Pathway',
    value: 'Pathway'

}, {

    key: 'Piazza',
    value: 'Piazza'

}, {

    key: 'Pier',
    value: 'Pier'

}, {

    key: 'Place',
    value: 'Place'

}, {

    key: 'Plateau',
    value: 'Plateau'

}, {

    key: 'Plaza',
    value: 'Plaza'

}, {

    key: 'Pocket',
    value: 'Pocket'

}, {

    key: 'Point',
    value: 'Point'

}, {

    key: 'Port',
    value: 'Port'

}, {

    key: 'Promenade',
    value: 'Promenade'

}, {

    key: 'Pursuit',
    value: 'Pursuit'

}, {

    key: 'Quad',
    value: 'Quad'

}, {

    key: 'Quadrangle',
    value: 'Quadrangle'

}, {

    key: 'Quadrant',
    value: 'Quadrant'

}, {

    key: 'Quay',
    value: 'Quay'

}, {

    key: 'Quays',
    value: 'Quays'

}, {

    key: 'Railway',
    value: 'Railway'

}, {

    key: 'Siding',
    value: 'Siding'

}, {

    key: 'Ramble',
    value: 'Ramble'

}, {

    key: 'Ramp',
    value: 'Ramp'

}, {

    key: 'Range',
    value: 'Range'

}, {

    key: 'Reach',
    value: 'Reach'

}, {

    key: 'Reserve',
    value: 'Reserve'

}, {

    key: 'Rest',
    value: 'Rest'

}, {

    key: 'Retreat',
    value: 'Retreat'

}, {

    key: 'Return',
    value: 'Return'

}, {

    key: 'Ride',
    value: 'Ride'

}, {

    key: 'Ridge',
    value: 'Ridge'

}, {

    key: 'Ridgeway',
    value: 'Ridgeway'

}, {

    key: 'Right',
    value: 'Right'

}, {

    key: 'of',
    value: 'of'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Ring',
    value: 'Ring'

}, {

    key: 'Rise',
    value: 'Rise'

}, {

    key: 'River',
    value: 'River'

}, {

    key: 'Riverway',
    value: 'Riverway'

}, {

    key: 'Riviera',
    value: 'Riviera'

}, {

    key: 'Road',
    value: 'Road'

}, {

    key: 'Roads',
    value: 'Roads'

}, {

    key: 'Roadside',
    value: 'Roadside'

}, {

    key: 'Roadway',
    value: 'Roadway'

}, {

    key: 'Ronde',
    value: 'Ronde'

}, {

    key: 'Rosebowl',
    value: 'Rosebowl'

}, {

    key: 'Rotary',
    value: 'Rotary'

}, {

    key: 'Round',
    value: 'Round'

}, {

    key: 'Route',
    value: 'Route'

}, {

    key: 'Row',
    value: 'Row'

}, {

    key: 'Rue',
    value: 'Rue'

}, {

    key: 'Run',
    value: 'Run'

}, {

    key: 'Service',
    value: 'Service'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Siding',
    value: 'Siding'

}, {

    key: 'Slope',
    value: 'Slope'

}, {

    key: 'Sound',
    value: 'Sound'

}, {

    key: 'Spur',
    value: 'Spur'

}, {

    key: 'Square',
    value: 'Square'

}, {

    key: 'Stairs',
    value: 'Stairs'

}, {

    key: 'State',
    value: 'State'

}, {

    key: 'Highway',
    value: 'Highway'

}, {

    key: 'Steps',
    value: 'Steps'

}, {

    key: 'Strand',
    value: 'Strand'

}, {

    key: 'Street',
    value: 'Street'

}, {

    key: 'Strip',
    value: 'Strip'

}, {

    key: 'Subway',
    value: 'Subway'

}, {

    key: 'Tarn',
    value: 'Tarn'

}, {

    key: 'Terrace',
    value: 'Terrace'

}, {

    key: 'Thoroughfare',
    value: 'Thoroughfare'

}, {

    key: 'Tollway',
    value: 'Tollway'

}, {

    key: 'Top',
    value: 'Top'

}, {

    key: 'Tor',
    value: 'Tor'

}, {

    key: 'Towers',
    value: 'Towers'

}, {

    key: 'Track',
    value: 'Track'

}, {

    key: 'Trail',
    value: 'Trail'

}, {

    key: 'Trailer',
    value: 'Trailer'

}, {

    key: 'Triangle',
    value: 'Triangle'

}, {

    key: 'Trunkway',
    value: 'Trunkway'

}, {

    key: 'Turn',
    value: 'Turn'

}, {

    key: 'Underpass',
    value: 'Underpass'

}, {

    key: 'Upper',
    value: 'Upper'

}, {

    key: 'Vale',
    value: 'Vale'

}, {

    key: 'Viaduct',
    value: 'Viaduct'

}, {

    key: 'View',
    value: 'View'

}, {

    key: 'Villas',
    value: 'Villas'

}, {

    key: 'Vista',
    value: 'Vista'

}, {

    key: 'Wade',
    value: 'Wade'

}, {

    key: 'Walk',
    value: 'Walk'

}, {

    key: 'Walkway',
    value: 'Walkway'

}, {

    key: 'Waters',
    value: 'Waters'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Wharf',
    value: 'Wharf'

}, {

    key: 'Wood',
    value: 'Wood'

}, {

    key: 'Wynd',
    value: 'Wynd'

}, {

    key: 'Yard',
    value: 'Yard'

}, {

    key: 'Access',
    value: 'Access'

}, {

    key: 'Alley',
    value: 'Alley'

}, {

    key: 'Alleyway',
    value: 'Alleyway'

}, {

    key: 'Amble',
    value: 'Amble'

}, {

    key: 'Anchorage',
    value: 'Anchorage'

}, {

    key: 'Approach',
    value: 'Approach'

}, {

    key: 'Arcade',
    value: 'Arcade'

}, {

    key: 'Artery',
    value: 'Artery'

}, {

    key: 'Avenue',
    value: 'Avenue'

}, {

    key: 'Basin',
    value: 'Basin'

}, {

    key: 'Bank',
    value: 'Bank'

}, {

    key: 'Bay',
    value: 'Bay'

}, {

    key: 'Beach',
    value: 'Beach'

}, {

    key: 'Bend',
    value: 'Bend'

}, {

    key: 'Block',
    value: 'Block'

}, {

    key: 'Boundary',
    value: 'Boundary'

}, {

    key: 'Bowl',
    value: 'Bowl'

}, {

    key: 'Boulevard',
    value: 'Boulevard'

}, {

    key: 'Brace',
    value: 'Brace'

}, {

    key: 'Branch',
    value: 'Branch'

}, {

    key: 'Brae',
    value: 'Brae'

}, {

    key: 'Break',
    value: 'Break'

}, {

    key: 'Bridge',
    value: 'Bridge'

}, {

    key: 'Broadway',
    value: 'Broadway'

}, {

    key: 'Brow',
    value: 'Brow'

}, {

    key: 'Bypass',
    value: 'Bypass'

}, {

    key: 'Byway',
    value: 'Byway'

}, {

    key: 'Causeway',
    value: 'Causeway'

}, {

    key: 'Centre',
    value: 'Centre'

}, {

    key: 'Centreway',
    value: 'Centreway'

}, {

    key: 'Chase',
    value: 'Chase'

}, {

    key: 'Circle',
    value: 'Circle'

}, {

    key: 'Circlet',
    value: 'Circlet'

}, {

    key: 'Circuit',
    value: 'Circuit'

}, {

    key: 'Circus',
    value: 'Circus'

}, {

    key: 'Close',
    value: 'Close'

}, {

    key: 'Colonnade',
    value: 'Colonnade'

}, {

    key: 'Common',
    value: 'Common'

}, {

    key: 'Concourse',
    value: 'Concourse'

}, {

    key: 'Copse',
    value: 'Copse'

}, {

    key: 'Corner',
    value: 'Corner'

}, {

    key: 'Corso',
    value: 'Corso'

}, {

    key: 'Court',
    value: 'Court'

}, {

    key: 'Course',
    value: 'Course'

}, {

    key: 'Courtyard',
    value: 'Courtyard'

}, {

    key: 'Cove',
    value: 'Cove'

}, {

    key: 'Crescent',
    value: 'Crescent'

}, {

    key: 'Crest',
    value: 'Crest'

}, {

    key: 'Creek',
    value: 'Creek'

}, {

    key: 'Cross',
    value: 'Cross'

}, {

    key: 'Crossing',
    value: 'Crossing'

}, {

    key: 'Crossroad',
    value: 'Crossroad'

}, {

    key: 'Crossway',
    value: 'Crossway'

}, {

    key: 'Crief',
    value: 'Crief'

}, {

    key: 'Cruiseway',
    value: 'Cruiseway'

}, {

    key: 'Cul-de-sac',
    value: 'Cul-de-sac'

}, {

    key: 'Cutting',
    value: 'Cutting'

}, {

    key: 'Dale',
    value: 'Dale'

}, {

    key: 'Dell',
    value: 'Dell'

}, {

    key: 'Deviation',
    value: 'Deviation'

}, {

    key: 'Dip',
    value: 'Dip'

}, {

    key: 'Distributor',
    value: 'Distributor'

}, {

    key: 'Downs',
    value: 'Downs'

}, {

    key: 'Drive',
    value: 'Drive'

}, {

    key: 'Driveway',
    value: 'Driveway'

}, {

    key: 'Easement',
    value: 'Easement'

}, {

    key: 'Edge',
    value: 'Edge'

}, {

    key: 'Elbow',
    value: 'Elbow'

}, {

    key: 'End',
    value: 'End'

}, {

    key: 'Entrance',
    value: 'Entrance'

}, {

    key: 'Esplanade',
    value: 'Esplanade'

}, {

    key: 'Estate',
    value: 'Estate'

}, {

    key: 'Expressway',
    value: 'Expressway'

}, {

    key: 'Extension',
    value: 'Extension'

}, {

    key: 'Fairway',
    value: 'Fairway'

}, {

    key: 'Fire',
    value: 'Fire'

}, {

    key: 'track',
    value: 'track'

}, {

    key: 'Firetrail',
    value: 'Firetrail'

}, {

    key: 'Flat',
    value: 'Flat'

}, {

    key: 'Follow',
    value: 'Follow'

}, {

    key: 'Footway',
    value: 'Footway'

}, {

    key: 'Foreshore',
    value: 'Foreshore'

}, {

    key: 'Formation',
    value: 'Formation'

}, {

    key: 'Freeway',
    value: 'Freeway'

}, {

    key: 'Front',
    value: 'Front'

}, {

    key: 'Frontage',
    value: 'Frontage'

}, {

    key: 'Gap',
    value: 'Gap'

}, {

    key: 'Garden',
    value: 'Garden'

}, {

    key: 'Gardens',
    value: 'Gardens'

}, {

    key: 'Gate',
    value: 'Gate'

}, {

    key: 'Gateway',
    value: 'Gateway'

}, {

    key: 'Gates',
    value: 'Gates'

}, {

    key: 'Glade',
    value: 'Glade'

}, {

    key: 'Glen',
    value: 'Glen'

}, {

    key: 'Grange',
    value: 'Grange'

}, {

    key: 'Green',
    value: 'Green'

}, {

    key: 'Ground',
    value: 'Ground'

}, {

    key: 'Grove',
    value: 'Grove'

}, {

    key: 'Gully',
    value: 'Gully'

}, {

    key: 'Heath',
    value: 'Heath'

}, {

    key: 'Heights',
    value: 'Heights'

}, {

    key: 'Highroad',
    value: 'Highroad'

}, {

    key: 'Highway',
    value: 'Highway'

}, {

    key: 'Hill',
    value: 'Hill'

}, {

    key: 'Interchange',
    value: 'Interchange'

}, {

    key: 'Intersection',
    value: 'Intersection'

}, {

    key: 'Junction',
    value: 'Junction'

}, {

    key: 'Landing',
    value: 'Landing'

}, {

    key: 'Lane',
    value: 'Lane'

}, {

    key: 'Laneway',
    value: 'Laneway'

}, {

    key: 'Lees',
    value: 'Lees'

}, {

    key: 'Line',
    value: 'Line'

}, {

    key: 'Link',
    value: 'Link'

}, {

    key: 'Little',
    value: 'Little'

}, {

    key: 'Location',
    value: 'Location'

}, {

    key: 'Lookout',
    value: 'Lookout'

}, {

    key: 'Loop',
    value: 'Loop'

}, {

    key: 'Lower',
    value: 'Lower'

}, {

    key: 'Mall',
    value: 'Mall'

}, {

    key: 'Meander',
    value: 'Meander'

}, {

    key: 'Mew',
    value: 'Mew'

}, {

    key: 'Mews',
    value: 'Mews'

}, {

    key: 'Motorway',
    value: 'Motorway'

}, {

    key: 'Mount',
    value: 'Mount'

}, {

    key: 'Nook',
    value: 'Nook'

}, {

    key: 'Outlook',
    value: 'Outlook'

}, {

    key: 'Parade',
    value: 'Parade'

}, {

    key: 'Park',
    value: 'Park'

}, {

    key: 'Parklands',
    value: 'Parklands'

}, {

    key: 'Parkway',
    value: 'Parkway'

}, {

    key: 'Part',
    value: 'Part'

}, {

    key: 'Pass',
    value: 'Pass'

}, {

    key: 'Path',
    value: 'Path'

}, {

    key: 'Pathway',
    value: 'Pathway'

}, {

    key: 'Piazza',
    value: 'Piazza'

}, {

    key: 'Pier',
    value: 'Pier'

}, {

    key: 'Place',
    value: 'Place'

}, {

    key: 'Plateau',
    value: 'Plateau'

}, {

    key: 'Plaza',
    value: 'Plaza'

}, {

    key: 'Pocket',
    value: 'Pocket'

}, {

    key: 'Point',
    value: 'Point'

}, {

    key: 'Port',
    value: 'Port'

}, {

    key: 'Promenade',
    value: 'Promenade'

}, {

    key: 'Pursuit',
    value: 'Pursuit'

}, {

    key: 'Quad',
    value: 'Quad'

}, {

    key: 'Quadrangle',
    value: 'Quadrangle'

}, {

    key: 'Quadrant',
    value: 'Quadrant'

}, {

    key: 'Quay',
    value: 'Quay'

}, {

    key: 'Quays',
    value: 'Quays'

}, {

    key: 'Railway',
    value: 'Railway'

}, {

    key: 'Siding',
    value: 'Siding'

}, {

    key: 'Ramble',
    value: 'Ramble'

}, {

    key: 'Ramp',
    value: 'Ramp'

}, {

    key: 'Range',
    value: 'Range'

}, {

    key: 'Reach',
    value: 'Reach'

}, {

    key: 'Reserve',
    value: 'Reserve'

}, {

    key: 'Rest',
    value: 'Rest'

}, {

    key: 'Retreat',
    value: 'Retreat'

}, {

    key: 'Return',
    value: 'Return'

}, {

    key: 'Ride',
    value: 'Ride'

}, {

    key: 'Ridge',
    value: 'Ridge'

}, {

    key: 'Ridgeway',
    value: 'Ridgeway'

}, {

    key: 'Right',
    value: 'Right'

}, {

    key: 'of',
    value: 'of'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Ring',
    value: 'Ring'

}, {

    key: 'Rise',
    value: 'Rise'

}, {

    key: 'River',
    value: 'River'

}, {

    key: 'Riverway',
    value: 'Riverway'

}, {

    key: 'Riviera',
    value: 'Riviera'

}, {

    key: 'Road',
    value: 'Road'

}, {

    key: 'Roads',
    value: 'Roads'

}, {

    key: 'Roadside',
    value: 'Roadside'

}, {

    key: 'Roadway',
    value: 'Roadway'

}, {

    key: 'Ronde',
    value: 'Ronde'

}, {

    key: 'Rosebowl',
    value: 'Rosebowl'

}, {

    key: 'Rotary',
    value: 'Rotary'

}, {

    key: 'Round',
    value: 'Round'

}, {

    key: 'Route',
    value: 'Route'

}, {

    key: 'Row',
    value: 'Row'

}, {

    key: 'Rue',
    value: 'Rue'

}, {

    key: 'Run',
    value: 'Run'

}, {

    key: 'Service',
    value: 'Service'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Siding',
    value: 'Siding'

}, {

    key: 'Slope',
    value: 'Slope'

}, {

    key: 'Sound',
    value: 'Sound'

}, {

    key: 'Spur',
    value: 'Spur'

}, {

    key: 'Square',
    value: 'Square'

}, {

    key: 'Stairs',
    value: 'Stairs'

}, {

    key: 'State',
    value: 'State'

}, {

    key: 'Highway',
    value: 'Highway'

}, {

    key: 'Steps',
    value: 'Steps'

}, {

    key: 'Strand',
    value: 'Strand'

}, {

    key: 'Street',
    value: 'Street'

}, {

    key: 'Strip',
    value: 'Strip'

}, {

    key: 'Subway',
    value: 'Subway'

}, {

    key: 'Tarn',
    value: 'Tarn'

}, {

    key: 'Terrace',
    value: 'Terrace'

}, {

    key: 'Thoroughfare',
    value: 'Thoroughfare'

}, {

    key: 'Tollway',
    value: 'Tollway'

}, {

    key: 'Top',
    value: 'Top'

}, {

    key: 'Tor',
    value: 'Tor'

}, {

    key: 'Towers',
    value: 'Towers'

}, {

    key: 'Track',
    value: 'Track'

}, {

    key: 'Trail',
    value: 'Trail'

}, {

    key: 'Trailer',
    value: 'Trailer'

}, {

    key: 'Triangle',
    value: 'Triangle'

}, {

    key: 'Trunkway',
    value: 'Trunkway'

}, {

    key: 'Turn',
    value: 'Turn'

}, {

    key: 'Underpass',
    value: 'Underpass'

}, {

    key: 'Upper',
    value: 'Upper'

}, {

    key: 'Vale',
    value: 'Vale'

}, {

    key: 'Viaduct',
    value: 'Viaduct'

}, {

    key: 'View',
    value: 'View'

}, {

    key: 'Villas',
    value: 'Villas'

}, {

    key: 'Vista',
    value: 'Vista'

}, {

    key: 'Wade',
    value: 'Wade'

}, {

    key: 'Walk',
    value: 'Walk'

}, {

    key: 'Walkway',
    value: 'Walkway'

}, {

    key: 'Waters',
    value: 'Waters'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Wharf',
    value: 'Wharf'

}, {

    key: 'Wood',
    value: 'Wood'

}, {

    key: 'Wynd',
    value: 'Wynd'

}, {

    key: 'Yard',
    value: 'Yard'

}, {

    key: 'Access',
    value: 'Access'

}, {

    key: 'Alley',
    value: 'Alley'

}, {

    key: 'Alleyway',
    value: 'Alleyway'

}, {

    key: 'Amble',
    value: 'Amble'

}, {

    key: 'Anchorage',
    value: 'Anchorage'

}, {

    key: 'Approach',
    value: 'Approach'

}, {

    key: 'Arcade',
    value: 'Arcade'

}, {

    key: 'Artery',
    value: 'Artery'

}, {

    key: 'Avenue',
    value: 'Avenue'

}, {

    key: 'Basin',
    value: 'Basin'

}, {

    key: 'Bank',
    value: 'Bank'

}, {

    key: 'Bay',
    value: 'Bay'

}, {

    key: 'Beach',
    value: 'Beach'

}, {

    key: 'Bend',
    value: 'Bend'

}, {

    key: 'Block',
    value: 'Block'

}, {

    key: 'Boundary',
    value: 'Boundary'

}, {

    key: 'Bowl',
    value: 'Bowl'

}, {

    key: 'Boulevard',
    value: 'Boulevard'

}, {

    key: 'Brace',
    value: 'Brace'

}, {

    key: 'Branch',
    value: 'Branch'

}, {

    key: 'Brae',
    value: 'Brae'

}, {

    key: 'Break',
    value: 'Break'

}, {

    key: 'Bridge',
    value: 'Bridge'

}, {

    key: 'Broadway',
    value: 'Broadway'

}, {

    key: 'Brow',
    value: 'Brow'

}, {

    key: 'Bypass',
    value: 'Bypass'

}, {

    key: 'Byway',
    value: 'Byway'

}, {

    key: 'Causeway',
    value: 'Causeway'

}, {

    key: 'Centre',
    value: 'Centre'

}, {

    key: 'Centreway',
    value: 'Centreway'

}, {

    key: 'Chase',
    value: 'Chase'

}, {

    key: 'Circle',
    value: 'Circle'

}, {

    key: 'Circlet',
    value: 'Circlet'

}, {

    key: 'Circuit',
    value: 'Circuit'

}, {

    key: 'Circus',
    value: 'Circus'

}, {

    key: 'Close',
    value: 'Close'

}, {

    key: 'Colonnade',
    value: 'Colonnade'

}, {

    key: 'Common',
    value: 'Common'

}, {

    key: 'Concourse',
    value: 'Concourse'

}, {

    key: 'Copse',
    value: 'Copse'

}, {

    key: 'Corner',
    value: 'Corner'

}, {

    key: 'Corso',
    value: 'Corso'

}, {

    key: 'Court',
    value: 'Court'

}, {

    key: 'Course',
    value: 'Course'

}, {

    key: 'Courtyard',
    value: 'Courtyard'

}, {

    key: 'Cove',
    value: 'Cove'

}, {

    key: 'Crescent',
    value: 'Crescent'

}, {

    key: 'Crest',
    value: 'Crest'

}, {

    key: 'Creek',
    value: 'Creek'

}, {

    key: 'Cross',
    value: 'Cross'

}, {

    key: 'Crossing',
    value: 'Crossing'

}, {

    key: 'Crossroad',
    value: 'Crossroad'

}, {

    key: 'Crossway',
    value: 'Crossway'

}, {

    key: 'Crief',
    value: 'Crief'

}, {

    key: 'Cruiseway',
    value: 'Cruiseway'

}, {

    key: 'Cul-de-sac',
    value: 'Cul-de-sac'

}, {

    key: 'Cutting',
    value: 'Cutting'

}, {

    key: 'Dale',
    value: 'Dale'

}, {

    key: 'Dell',
    value: 'Dell'

}, {

    key: 'Deviation',
    value: 'Deviation'

}, {

    key: 'Dip',
    value: 'Dip'

}, {

    key: 'Distributor',
    value: 'Distributor'

}, {

    key: 'Downs',
    value: 'Downs'

}, {

    key: 'Drive',
    value: 'Drive'

}, {

    key: 'Driveway',
    value: 'Driveway'

}, {

    key: 'Easement',
    value: 'Easement'

}, {

    key: 'Edge',
    value: 'Edge'

}, {

    key: 'Elbow',
    value: 'Elbow'

}, {

    key: 'End',
    value: 'End'

}, {

    key: 'Entrance',
    value: 'Entrance'

}, {

    key: 'Esplanade',
    value: 'Esplanade'

}, {

    key: 'Estate',
    value: 'Estate'

}, {

    key: 'Expressway',
    value: 'Expressway'

}, {

    key: 'Extension',
    value: 'Extension'

}, {

    key: 'Fairway',
    value: 'Fairway'

}, {

    key: 'Fire',
    value: 'Fire'

}, {

    key: 'track',
    value: 'track'

}, {

    key: 'Firetrail',
    value: 'Firetrail'

}, {

    key: 'Flat',
    value: 'Flat'

}, {

    key: 'Follow',
    value: 'Follow'

}, {

    key: 'Footway',
    value: 'Footway'

}, {

    key: 'Foreshore',
    value: 'Foreshore'

}, {

    key: 'Formation',
    value: 'Formation'

}, {

    key: 'Freeway',
    value: 'Freeway'

}, {

    key: 'Front',
    value: 'Front'

}, {

    key: 'Frontage',
    value: 'Frontage'

}, {

    key: 'Gap',
    value: 'Gap'

}, {

    key: 'Garden',
    value: 'Garden'

}, {

    key: 'Gardens',
    value: 'Gardens'

}, {

    key: 'Gate',
    value: 'Gate'

}, {

    key: 'Gateway',
    value: 'Gateway'

}, {

    key: 'Gates',
    value: 'Gates'

}, {

    key: 'Glade',
    value: 'Glade'

}, {

    key: 'Glen',
    value: 'Glen'

}, {

    key: 'Grange',
    value: 'Grange'

}, {

    key: 'Green',
    value: 'Green'

}, {

    key: 'Ground',
    value: 'Ground'

}, {

    key: 'Grove',
    value: 'Grove'

}, {

    key: 'Gully',
    value: 'Gully'

}, {

    key: 'Heath',
    value: 'Heath'

}, {

    key: 'Heights',
    value: 'Heights'

}, {

    key: 'Highroad',
    value: 'Highroad'

}, {

    key: 'Highway',
    value: 'Highway'

}, {

    key: 'Hill',
    value: 'Hill'

}, {

    key: 'Interchange',
    value: 'Interchange'

}, {

    key: 'Intersection',
    value: 'Intersection'

}, {

    key: 'Junction',
    value: 'Junction'

}, {

    key: 'Landing',
    value: 'Landing'

}, {

    key: 'Lane',
    value: 'Lane'

}, {

    key: 'Laneway',
    value: 'Laneway'

}, {

    key: 'Lees',
    value: 'Lees'

}, {

    key: 'Line',
    value: 'Line'

}, {

    key: 'Link',
    value: 'Link'

}, {

    key: 'Little',
    value: 'Little'

}, {

    key: 'Location',
    value: 'Location'

}, {

    key: 'Lookout',
    value: 'Lookout'

}, {

    key: 'Loop',
    value: 'Loop'

}, {

    key: 'Lower',
    value: 'Lower'

}, {

    key: 'Mall',
    value: 'Mall'

}, {

    key: 'Meander',
    value: 'Meander'

}, {

    key: 'Mew',
    value: 'Mew'

}, {

    key: 'Mews',
    value: 'Mews'

}, {

    key: 'Motorway',
    value: 'Motorway'

}, {

    key: 'Mount',
    value: 'Mount'

}, {

    key: 'Nook',
    value: 'Nook'

}, {

    key: 'Outlook',
    value: 'Outlook'

}, {

    key: 'Parade',
    value: 'Parade'

}, {

    key: 'Park',
    value: 'Park'

}, {

    key: 'Parklands',
    value: 'Parklands'

}, {

    key: 'Parkway',
    value: 'Parkway'

}, {

    key: 'Part',
    value: 'Part'

}, {

    key: 'Pass',
    value: 'Pass'

}, {

    key: 'Path',
    value: 'Path'

}, {

    key: 'Pathway',
    value: 'Pathway'

}, {

    key: 'Piazza',
    value: 'Piazza'

}, {

    key: 'Pier',
    value: 'Pier'

}, {

    key: 'Place',
    value: 'Place'

}, {

    key: 'Plateau',
    value: 'Plateau'

}, {

    key: 'Plaza',
    value: 'Plaza'

}, {

    key: 'Pocket',
    value: 'Pocket'

}, {

    key: 'Point',
    value: 'Point'

}, {

    key: 'Port',
    value: 'Port'

}, {

    key: 'Promenade',
    value: 'Promenade'

}, {

    key: 'Pursuit',
    value: 'Pursuit'

}, {

    key: 'Quad',
    value: 'Quad'

}, {

    key: 'Quadrangle',
    value: 'Quadrangle'

}, {

    key: 'Quadrant',
    value: 'Quadrant'

}, {

    key: 'Quay',
    value: 'Quay'

}, {

    key: 'Quays',
    value: 'Quays'

}, {

    key: 'Railway',
    value: 'Railway'

}, {

    key: 'Siding',
    value: 'Siding'

}, {

    key: 'Ramble',
    value: 'Ramble'

}, {

    key: 'Ramp',
    value: 'Ramp'

}, {

    key: 'Range',
    value: 'Range'

}, {

    key: 'Reach',
    value: 'Reach'

}, {

    key: 'Reserve',
    value: 'Reserve'

}, {

    key: 'Rest',
    value: 'Rest'

}, {

    key: 'Retreat',
    value: 'Retreat'

}, {

    key: 'Return',
    value: 'Return'

}, {

    key: 'Ride',
    value: 'Ride'

}, {

    key: 'Ridge',
    value: 'Ridge'

}, {

    key: 'Ridgeway',
    value: 'Ridgeway'

}, {

    key: 'Right',
    value: 'Right'

}, {

    key: 'of',
    value: 'of'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Ring',
    value: 'Ring'

}, {

    key: 'Rise',
    value: 'Rise'

}, {

    key: 'River',
    value: 'River'

}, {

    key: 'Riverway',
    value: 'Riverway'

}, {

    key: 'Riviera',
    value: 'Riviera'

}, {

    key: 'Road',
    value: 'Road'

}, {

    key: 'Roads',
    value: 'Roads'

}, {

    key: 'Roadside',
    value: 'Roadside'

}, {

    key: 'Roadway',
    value: 'Roadway'

}, {

    key: 'Ronde',
    value: 'Ronde'

}, {

    key: 'Rosebowl',
    value: 'Rosebowl'

}, {

    key: 'Rotary',
    value: 'Rotary'

}, {

    key: 'Round',
    value: 'Round'

}, {

    key: 'Route',
    value: 'Route'

}, {

    key: 'Row',
    value: 'Row'

}, {

    key: 'Rue',
    value: 'Rue'

}, {

    key: 'Run',
    value: 'Run'

}, {

    key: 'Service',
    value: 'Service'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Siding',
    value: 'Siding'

}, {

    key: 'Slope',
    value: 'Slope'

}, {

    key: 'Sound',
    value: 'Sound'

}, {

    key: 'Spur',
    value: 'Spur'

}, {

    key: 'Square',
    value: 'Square'

}, {

    key: 'Stairs',
    value: 'Stairs'

}, {

    key: 'State',
    value: 'State'

}, {

    key: 'Highway',
    value: 'Highway'

}, {

    key: 'Steps',
    value: 'Steps'

}, {

    key: 'Strand',
    value: 'Strand'

}, {

    key: 'Street',
    value: 'Street'

}, {

    key: 'Strip',
    value: 'Strip'

}, {

    key: 'Subway',
    value: 'Subway'

}, {

    key: 'Tarn',
    value: 'Tarn'

}, {

    key: 'Terrace',
    value: 'Terrace'

}, {

    key: 'Thoroughfare',
    value: 'Thoroughfare'

}, {

    key: 'Tollway',
    value: 'Tollway'

}, {

    key: 'Top',
    value: 'Top'

}, {

    key: 'Tor',
    value: 'Tor'

}, {

    key: 'Towers',
    value: 'Towers'

}, {

    key: 'Track',
    value: 'Track'

}, {

    key: 'Trail',
    value: 'Trail'

}, {

    key: 'Trailer',
    value: 'Trailer'

}, {

    key: 'Triangle',
    value: 'Triangle'

}, {

    key: 'Trunkway',
    value: 'Trunkway'

}, {

    key: 'Turn',
    value: 'Turn'

}, {

    key: 'Underpass',
    value: 'Underpass'

}, {

    key: 'Upper',
    value: 'Upper'

}, {

    key: 'Vale',
    value: 'Vale'

}, {

    key: 'Viaduct',
    value: 'Viaduct'

}, {

    key: 'View',
    value: 'View'

}, {

    key: 'Villas',
    value: 'Villas'

}, {

    key: 'Vista',
    value: 'Vista'

}, {

    key: 'Wade',
    value: 'Wade'

}, {

    key: 'Walk',
    value: 'Walk'

}, {

    key: 'Walkway',
    value: 'Walkway'

}, {

    key: 'Waters',
    value: 'Waters'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Wharf',
    value: 'Wharf'

}, {

    key: 'Wood',
    value: 'Wood'

}, {

    key: 'Wynd',
    value: 'Wynd'

}, {

    key: 'Yard',
    value: 'Yard'

}, {

    key: 'Access',
    value: 'Access'

}, {

    key: 'Alley',
    value: 'Alley'

}, {

    key: 'Alleyway',
    value: 'Alleyway'

}, {

    key: 'Amble',
    value: 'Amble'

}, {

    key: 'Anchorage',
    value: 'Anchorage'

}, {

    key: 'Approach',
    value: 'Approach'

}, {

    key: 'Arcade',
    value: 'Arcade'

}, {

    key: 'Artery',
    value: 'Artery'

}, {

    key: 'Avenue',
    value: 'Avenue'

}, {

    key: 'Basin',
    value: 'Basin'

}, {

    key: 'Bank',
    value: 'Bank'

}, {

    key: 'Bay',
    value: 'Bay'

}, {

    key: 'Beach',
    value: 'Beach'

}, {

    key: 'Bend',
    value: 'Bend'

}, {

    key: 'Block',
    value: 'Block'

}, {

    key: 'Boundary',
    value: 'Boundary'

}, {

    key: 'Bowl',
    value: 'Bowl'

}, {

    key: 'Boulevard',
    value: 'Boulevard'

}, {

    key: 'Brace',
    value: 'Brace'

}, {

    key: 'Branch',
    value: 'Branch'

}, {

    key: 'Brae',
    value: 'Brae'

}, {

    key: 'Break',
    value: 'Break'

}, {

    key: 'Bridge',
    value: 'Bridge'

}, {

    key: 'Broadway',
    value: 'Broadway'

}, {

    key: 'Brow',
    value: 'Brow'

}, {

    key: 'Bypass',
    value: 'Bypass'

}, {

    key: 'Byway',
    value: 'Byway'

}, {

    key: 'Causeway',
    value: 'Causeway'

}, {

    key: 'Centre',
    value: 'Centre'

}, {

    key: 'Centreway',
    value: 'Centreway'

}, {

    key: 'Chase',
    value: 'Chase'

}, {

    key: 'Circle',
    value: 'Circle'

}, {

    key: 'Circlet',
    value: 'Circlet'

}, {

    key: 'Circuit',
    value: 'Circuit'

}, {

    key: 'Circus',
    value: 'Circus'

}, {

    key: 'Close',
    value: 'Close'

}, {

    key: 'Colonnade',
    value: 'Colonnade'

}, {

    key: 'Common',
    value: 'Common'

}, {

    key: 'Concourse',
    value: 'Concourse'

}, {

    key: 'Copse',
    value: 'Copse'

}, {

    key: 'Corner',
    value: 'Corner'

}, {

    key: 'Corso',
    value: 'Corso'

}, {

    key: 'Court',
    value: 'Court'

}, {

    key: 'Course',
    value: 'Course'

}, {

    key: 'Courtyard',
    value: 'Courtyard'

}, {

    key: 'Cove',
    value: 'Cove'

}, {

    key: 'Crescent',
    value: 'Crescent'

}, {

    key: 'Crest',
    value: 'Crest'

}, {

    key: 'Creek',
    value: 'Creek'

}, {

    key: 'Cross',
    value: 'Cross'

}, {

    key: 'Crossing',
    value: 'Crossing'

}, {

    key: 'Crossroad',
    value: 'Crossroad'

}, {

    key: 'Crossway',
    value: 'Crossway'

}, {

    key: 'Crief',
    value: 'Crief'

}, {

    key: 'Cruiseway',
    value: 'Cruiseway'

}, {

    key: 'Cul-de-sac',
    value: 'Cul-de-sac'

}, {

    key: 'Cutting',
    value: 'Cutting'

}, {

    key: 'Dale',
    value: 'Dale'

}, {

    key: 'Dell',
    value: 'Dell'

}, {

    key: 'Deviation',
    value: 'Deviation'

}, {

    key: 'Dip',
    value: 'Dip'

}, {

    key: 'Distributor',
    value: 'Distributor'

}, {

    key: 'Downs',
    value: 'Downs'

}, {

    key: 'Drive',
    value: 'Drive'

}, {

    key: 'Driveway',
    value: 'Driveway'

}, {

    key: 'Easement',
    value: 'Easement'

}, {

    key: 'Edge',
    value: 'Edge'

}, {

    key: 'Elbow',
    value: 'Elbow'

}, {

    key: 'End',
    value: 'End'

}, {

    key: 'Entrance',
    value: 'Entrance'

}, {

    key: 'Esplanade',
    value: 'Esplanade'

}, {

    key: 'Estate',
    value: 'Estate'

}, {

    key: 'Expressway',
    value: 'Expressway'

}, {

    key: 'Extension',
    value: 'Extension'

}, {

    key: 'Fairway',
    value: 'Fairway'

}, {

    key: 'Fire',
    value: 'Fire'

}, {

    key: 'track',
    value: 'track'

}, {

    key: 'Firetrail',
    value: 'Firetrail'

}, {

    key: 'Flat',
    value: 'Flat'

}, {

    key: 'Follow',
    value: 'Follow'

}, {

    key: 'Footway',
    value: 'Footway'

}, {

    key: 'Foreshore',
    value: 'Foreshore'

}, {

    key: 'Formation',
    value: 'Formation'

}, {

    key: 'Freeway',
    value: 'Freeway'

}, {

    key: 'Front',
    value: 'Front'

}, {

    key: 'Frontage',
    value: 'Frontage'

}, {

    key: 'Gap',
    value: 'Gap'

}, {

    key: 'Garden',
    value: 'Garden'

}, {

    key: 'Gardens',
    value: 'Gardens'

}, {

    key: 'Gate',
    value: 'Gate'

}, {

    key: 'Gateway',
    value: 'Gateway'

}, {

    key: 'Gates',
    value: 'Gates'

}, {

    key: 'Glade',
    value: 'Glade'

}, {

    key: 'Glen',
    value: 'Glen'

}, {

    key: 'Grange',
    value: 'Grange'

}, {

    key: 'Green',
    value: 'Green'

}, {

    key: 'Ground',
    value: 'Ground'

}, {

    key: 'Grove',
    value: 'Grove'

}, {

    key: 'Gully',
    value: 'Gully'

}, {

    key: 'Heath',
    value: 'Heath'

}, {

    key: 'Heights',
    value: 'Heights'

}, {

    key: 'Highroad',
    value: 'Highroad'

}, {

    key: 'Highway',
    value: 'Highway'

}, {

    key: 'Hill',
    value: 'Hill'

}, {

    key: 'Interchange',
    value: 'Interchange'

}, {

    key: 'Intersection',
    value: 'Intersection'

}, {

    key: 'Junction',
    value: 'Junction'

}, {

    key: 'Landing',
    value: 'Landing'

}, {

    key: 'Lane',
    value: 'Lane'

}, {

    key: 'Laneway',
    value: 'Laneway'

}, {

    key: 'Lees',
    value: 'Lees'

}, {

    key: 'Line',
    value: 'Line'

}, {

    key: 'Link',
    value: 'Link'

}, {

    key: 'Little',
    value: 'Little'

}, {

    key: 'Location',
    value: 'Location'

}, {

    key: 'Lookout',
    value: 'Lookout'

}, {

    key: 'Loop',
    value: 'Loop'

}, {

    key: 'Lower',
    value: 'Lower'

}, {

    key: 'Mall',
    value: 'Mall'

}, {

    key: 'Meander',
    value: 'Meander'

}, {

    key: 'Mew',
    value: 'Mew'

}, {

    key: 'Mews',
    value: 'Mews'

}, {

    key: 'Motorway',
    value: 'Motorway'

}, {

    key: 'Mount',
    value: 'Mount'

}, {

    key: 'Nook',
    value: 'Nook'

}, {

    key: 'Outlook',
    value: 'Outlook'

}, {

    key: 'Parade',
    value: 'Parade'

}, {

    key: 'Park',
    value: 'Park'

}, {

    key: 'Parklands',
    value: 'Parklands'

}, {

    key: 'Parkway',
    value: 'Parkway'

}, {

    key: 'Part',
    value: 'Part'

}, {

    key: 'Pass',
    value: 'Pass'

}, {

    key: 'Path',
    value: 'Path'

}, {

    key: 'Pathway',
    value: 'Pathway'

}, {

    key: 'Piazza',
    value: 'Piazza'

}, {

    key: 'Pier',
    value: 'Pier'

}, {

    key: 'Place',
    value: 'Place'

}, {

    key: 'Plateau',
    value: 'Plateau'

}, {

    key: 'Plaza',
    value: 'Plaza'

}, {

    key: 'Pocket',
    value: 'Pocket'

}, {

    key: 'Point',
    value: 'Point'

}, {

    key: 'Port',
    value: 'Port'

}, {

    key: 'Promenade',
    value: 'Promenade'

}, {

    key: 'Pursuit',
    value: 'Pursuit'

}, {

    key: 'Quad',
    value: 'Quad'

}, {

    key: 'Quadrangle',
    value: 'Quadrangle'

}, {

    key: 'Quadrant',
    value: 'Quadrant'

}, {

    key: 'Quay',
    value: 'Quay'

}, {

    key: 'Quays',
    value: 'Quays'

}, {

    key: 'Railway',
    value: 'Railway'

}, {

    key: 'Siding',
    value: 'Siding'

}, {

    key: 'Ramble',
    value: 'Ramble'

}, {

    key: 'Ramp',
    value: 'Ramp'

}, {

    key: 'Range',
    value: 'Range'

}, {

    key: 'Reach',
    value: 'Reach'

}, {

    key: 'Reserve',
    value: 'Reserve'

}, {

    key: 'Rest',
    value: 'Rest'

}, {

    key: 'Retreat',
    value: 'Retreat'

}, {

    key: 'Return',
    value: 'Return'

}, {

    key: 'Ride',
    value: 'Ride'

}, {

    key: 'Ridge',
    value: 'Ridge'

}, {

    key: 'Ridgeway',
    value: 'Ridgeway'

}, {

    key: 'Right',
    value: 'Right'

}, {

    key: 'of',
    value: 'of'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Ring',
    value: 'Ring'

}, {

    key: 'Rise',
    value: 'Rise'

}, {

    key: 'River',
    value: 'River'

}, {

    key: 'Riverway',
    value: 'Riverway'

}, {

    key: 'Riviera',
    value: 'Riviera'

}, {

    key: 'Road',
    value: 'Road'

}, {

    key: 'Roads',
    value: 'Roads'

}, {

    key: 'Roadside',
    value: 'Roadside'

}, {

    key: 'Roadway',
    value: 'Roadway'

}, {

    key: 'Ronde',
    value: 'Ronde'

}, {

    key: 'Rosebowl',
    value: 'Rosebowl'

}, {

    key: 'Rotary',
    value: 'Rotary'

}, {

    key: 'Round',
    value: 'Round'

}, {

    key: 'Route',
    value: 'Route'

}, {

    key: 'Row',
    value: 'Row'

}, {

    key: 'Rue',
    value: 'Rue'

}, {

    key: 'Run',
    value: 'Run'

}, {

    key: 'Service',
    value: 'Service'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Siding',
    value: 'Siding'

}, {

    key: 'Slope',
    value: 'Slope'

}, {

    key: 'Sound',
    value: 'Sound'

}, {

    key: 'Spur',
    value: 'Spur'

}, {

    key: 'Square',
    value: 'Square'

}, {

    key: 'Stairs',
    value: 'Stairs'

}, {

    key: 'State',
    value: 'State'

}, {

    key: 'Highway',
    value: 'Highway'

}, {

    key: 'Steps',
    value: 'Steps'

}, {

    key: 'Strand',
    value: 'Strand'

}, {

    key: 'Street',
    value: 'Street'

}, {

    key: 'Strip',
    value: 'Strip'

}, {

    key: 'Subway',
    value: 'Subway'

}, {

    key: 'Tarn',
    value: 'Tarn'

}, {

    key: 'Terrace',
    value: 'Terrace'

}, {

    key: 'Thoroughfare',
    value: 'Thoroughfare'

}, {

    key: 'Tollway',
    value: 'Tollway'

}, {

    key: 'Top',
    value: 'Top'

}, {

    key: 'Tor',
    value: 'Tor'

}, {

    key: 'Towers',
    value: 'Towers'

}, {

    key: 'Track',
    value: 'Track'

}, {

    key: 'Trail',
    value: 'Trail'

}, {

    key: 'Trailer',
    value: 'Trailer'

}, {

    key: 'Triangle',
    value: 'Triangle'

}, {

    key: 'Trunkway',
    value: 'Trunkway'

}, {

    key: 'Turn',
    value: 'Turn'

}, {

    key: 'Underpass',
    value: 'Underpass'

}, {

    key: 'Upper',
    value: 'Upper'

}, {

    key: 'Vale',
    value: 'Vale'

}, {

    key: 'Viaduct',
    value: 'Viaduct'

}, {

    key: 'View',
    value: 'View'

}, {

    key: 'Villas',
    value: 'Villas'

}, {

    key: 'Vista',
    value: 'Vista'

}, {

    key: 'Wade',
    value: 'Wade'

}, {

    key: 'Walk',
    value: 'Walk'

}, {

    key: 'Walkway',
    value: 'Walkway'

}, {

    key: 'Waters',
    value: 'Waters'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Wharf',
    value: 'Wharf'

}, {

    key: 'Wood',
    value: 'Wood'

}, {

    key: 'Wynd',
    value: 'Wynd'

}, {

    key: 'Yard',
    value: 'Yard'

}, {

    key: 'Access',
    value: 'Access'

}, {

    key: 'Alley',
    value: 'Alley'

}, {

    key: 'Alleyway',
    value: 'Alleyway'

}, {

    key: 'Amble',
    value: 'Amble'

}, {

    key: 'Anchorage',
    value: 'Anchorage'

}, {

    key: 'Approach',
    value: 'Approach'

}, {

    key: 'Arcade',
    value: 'Arcade'

}, {

    key: 'Artery',
    value: 'Artery'

}, {

    key: 'Avenue',
    value: 'Avenue'

}, {

    key: 'Basin',
    value: 'Basin'

}, {

    key: 'Bank',
    value: 'Bank'

}, {

    key: 'Bay',
    value: 'Bay'

}, {

    key: 'Beach',
    value: 'Beach'

}, {

    key: 'Bend',
    value: 'Bend'

}, {

    key: 'Block',
    value: 'Block'

}, {

    key: 'Boundary',
    value: 'Boundary'

}, {

    key: 'Bowl',
    value: 'Bowl'

}, {

    key: 'Boulevard',
    value: 'Boulevard'

}, {

    key: 'Brace',
    value: 'Brace'

}, {

    key: 'Branch',
    value: 'Branch'

}, {

    key: 'Brae',
    value: 'Brae'

}, {

    key: 'Break',
    value: 'Break'

}, {

    key: 'Bridge',
    value: 'Bridge'

}, {

    key: 'Broadway',
    value: 'Broadway'

}, {

    key: 'Brow',
    value: 'Brow'

}, {

    key: 'Bypass',
    value: 'Bypass'

}, {

    key: 'Byway',
    value: 'Byway'

}, {

    key: 'Causeway',
    value: 'Causeway'

}, {

    key: 'Centre',
    value: 'Centre'

}, {

    key: 'Centreway',
    value: 'Centreway'

}, {

    key: 'Chase',
    value: 'Chase'

}, {

    key: 'Circle',
    value: 'Circle'

}, {

    key: 'Circlet',
    value: 'Circlet'

}, {

    key: 'Circuit',
    value: 'Circuit'

}, {

    key: 'Circus',
    value: 'Circus'

}, {

    key: 'Close',
    value: 'Close'

}, {

    key: 'Colonnade',
    value: 'Colonnade'

}, {

    key: 'Common',
    value: 'Common'

}, {

    key: 'Concourse',
    value: 'Concourse'

}, {

    key: 'Copse',
    value: 'Copse'

}, {

    key: 'Corner',
    value: 'Corner'

}, {

    key: 'Corso',
    value: 'Corso'

}, {

    key: 'Court',
    value: 'Court'

}, {

    key: 'Course',
    value: 'Course'

}, {

    key: 'Courtyard',
    value: 'Courtyard'

}, {

    key: 'Cove',
    value: 'Cove'

}, {

    key: 'Crescent',
    value: 'Crescent'

}, {

    key: 'Crest',
    value: 'Crest'

}, {

    key: 'Creek',
    value: 'Creek'

}, {

    key: 'Cross',
    value: 'Cross'

}, {

    key: 'Crossing',
    value: 'Crossing'

}, {

    key: 'Crossroad',
    value: 'Crossroad'

}, {

    key: 'Crossway',
    value: 'Crossway'

}, {

    key: 'Crief',
    value: 'Crief'

}, {

    key: 'Cruiseway',
    value: 'Cruiseway'

}, {

    key: 'Cul-de-sac',
    value: 'Cul-de-sac'

}, {

    key: 'Cutting',
    value: 'Cutting'

}, {

    key: 'Dale',
    value: 'Dale'

}, {

    key: 'Dell',
    value: 'Dell'

}, {

    key: 'Deviation',
    value: 'Deviation'

}, {

    key: 'Dip',
    value: 'Dip'

}, {

    key: 'Distributor',
    value: 'Distributor'

}, {

    key: 'Downs',
    value: 'Downs'

}, {

    key: 'Drive',
    value: 'Drive'

}, {

    key: 'Driveway',
    value: 'Driveway'

}, {

    key: 'Easement',
    value: 'Easement'

}, {

    key: 'Edge',
    value: 'Edge'

}, {

    key: 'Elbow',
    value: 'Elbow'

}, {

    key: 'End',
    value: 'End'

}, {

    key: 'Entrance',
    value: 'Entrance'

}, {

    key: 'Esplanade',
    value: 'Esplanade'

}, {

    key: 'Estate',
    value: 'Estate'

}, {

    key: 'Expressway',
    value: 'Expressway'

}, {

    key: 'Extension',
    value: 'Extension'

}, {

    key: 'Fairway',
    value: 'Fairway'

}, {

    key: 'Fire',
    value: 'Fire'

}, {

    key: 'track',
    value: 'track'

}, {

    key: 'Firetrail',
    value: 'Firetrail'

}, {

    key: 'Flat',
    value: 'Flat'

}, {

    key: 'Follow',
    value: 'Follow'

}, {

    key: 'Footway',
    value: 'Footway'

}, {

    key: 'Foreshore',
    value: 'Foreshore'

}, {

    key: 'Formation',
    value: 'Formation'

}, {

    key: 'Freeway',
    value: 'Freeway'

}, {

    key: 'Front',
    value: 'Front'

}, {

    key: 'Frontage',
    value: 'Frontage'

}, {

    key: 'Gap',
    value: 'Gap'

}, {

    key: 'Garden',
    value: 'Garden'

}, {

    key: 'Gardens',
    value: 'Gardens'

}, {

    key: 'Gate',
    value: 'Gate'

}, {

    key: 'Gateway',
    value: 'Gateway'

}, {

    key: 'Gates',
    value: 'Gates'

}, {

    key: 'Glade',
    value: 'Glade'

}, {

    key: 'Glen',
    value: 'Glen'

}, {

    key: 'Grange',
    value: 'Grange'

}, {

    key: 'Green',
    value: 'Green'

}, {

    key: 'Ground',
    value: 'Ground'

}, {

    key: 'Grove',
    value: 'Grove'

}, {

    key: 'Gully',
    value: 'Gully'

}, {

    key: 'Heath',
    value: 'Heath'

}, {

    key: 'Heights',
    value: 'Heights'

}, {

    key: 'Highroad',
    value: 'Highroad'

}, {

    key: 'Highway',
    value: 'Highway'

}, {

    key: 'Hill',
    value: 'Hill'

}, {

    key: 'Interchange',
    value: 'Interchange'

}, {

    key: 'Intersection',
    value: 'Intersection'

}, {

    key: 'Junction',
    value: 'Junction'

}, {

    key: 'Landing',
    value: 'Landing'

}, {

    key: 'Lane',
    value: 'Lane'

}, {

    key: 'Laneway',
    value: 'Laneway'

}, {

    key: 'Lees',
    value: 'Lees'

}, {

    key: 'Line',
    value: 'Line'

}, {

    key: 'Link',
    value: 'Link'

}, {

    key: 'Little',
    value: 'Little'

}, {

    key: 'Location',
    value: 'Location'

}, {

    key: 'Lookout',
    value: 'Lookout'

}, {

    key: 'Loop',
    value: 'Loop'

}, {

    key: 'Lower',
    value: 'Lower'

}, {

    key: 'Mall',
    value: 'Mall'

}, {

    key: 'Meander',
    value: 'Meander'

}, {

    key: 'Mew',
    value: 'Mew'

}, {

    key: 'Mews',
    value: 'Mews'

}, {

    key: 'Motorway',
    value: 'Motorway'

}, {

    key: 'Mount',
    value: 'Mount'

}, {

    key: 'Nook',
    value: 'Nook'

}, {

    key: 'Outlook',
    value: 'Outlook'

}, {

    key: 'Parade',
    value: 'Parade'

}, {

    key: 'Park',
    value: 'Park'

}, {

    key: 'Parklands',
    value: 'Parklands'

}, {

    key: 'Parkway',
    value: 'Parkway'

}, {

    key: 'Part',
    value: 'Part'

}, {

    key: 'Pass',
    value: 'Pass'

}, {

    key: 'Path',
    value: 'Path'

}, {

    key: 'Pathway',
    value: 'Pathway'

}, {

    key: 'Piazza',
    value: 'Piazza'

}, {

    key: 'Pier',
    value: 'Pier'

}, {

    key: 'Place',
    value: 'Place'

}, {

    key: 'Plateau',
    value: 'Plateau'

}, {

    key: 'Plaza',
    value: 'Plaza'

}, {

    key: 'Pocket',
    value: 'Pocket'

}, {

    key: 'Point',
    value: 'Point'

}, {

    key: 'Port',
    value: 'Port'

}, {

    key: 'Promenade',
    value: 'Promenade'

}, {

    key: 'Pursuit',
    value: 'Pursuit'

}, {

    key: 'Quad',
    value: 'Quad'

}, {

    key: 'Quadrangle',
    value: 'Quadrangle'

}, {

    key: 'Quadrant',
    value: 'Quadrant'

}, {

    key: 'Quay',
    value: 'Quay'

}, {

    key: 'Quays',
    value: 'Quays'

}, {

    key: 'Railway',
    value: 'Railway'

}, {

    key: 'Siding',
    value: 'Siding'

}, {

    key: 'Ramble',
    value: 'Ramble'

}, {

    key: 'Ramp',
    value: 'Ramp'

}, {

    key: 'Range',
    value: 'Range'

}, {

    key: 'Reach',
    value: 'Reach'

}, {

    key: 'Reserve',
    value: 'Reserve'

}, {

    key: 'Rest',
    value: 'Rest'

}, {

    key: 'Retreat',
    value: 'Retreat'

}, {

    key: 'Return',
    value: 'Return'

}, {

    key: 'Ride',
    value: 'Ride'

}, {

    key: 'Ridge',
    value: 'Ridge'

}, {

    key: 'Ridgeway',
    value: 'Ridgeway'

}, {

    key: 'Right',
    value: 'Right'

}, {

    key: 'of',
    value: 'of'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Ring',
    value: 'Ring'

}, {

    key: 'Rise',
    value: 'Rise'

}, {

    key: 'River',
    value: 'River'

}, {

    key: 'Riverway',
    value: 'Riverway'

}, {

    key: 'Riviera',
    value: 'Riviera'

}, {

    key: 'Road',
    value: 'Road'

}, {

    key: 'Roads',
    value: 'Roads'

}, {

    key: 'Roadside',
    value: 'Roadside'

}, {

    key: 'Roadway',
    value: 'Roadway'

}, {

    key: 'Ronde',
    value: 'Ronde'

}, {

    key: 'Rosebowl',
    value: 'Rosebowl'

}, {

    key: 'Rotary',
    value: 'Rotary'

}, {

    key: 'Round',
    value: 'Round'

}, {

    key: 'Route',
    value: 'Route'

}, {

    key: 'Row',
    value: 'Row'

}, {

    key: 'Rue',
    value: 'Rue'

}, {

    key: 'Run',
    value: 'Run'

}, {

    key: 'Service',
    value: 'Service'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Siding',
    value: 'Siding'

}, {

    key: 'Slope',
    value: 'Slope'

}, {

    key: 'Sound',
    value: 'Sound'

}, {

    key: 'Spur',
    value: 'Spur'

}, {

    key: 'Square',
    value: 'Square'

}, {

    key: 'Stairs',
    value: 'Stairs'

}, {

    key: 'State',
    value: 'State'

}, {

    key: 'Highway',
    value: 'Highway'

}, {

    key: 'Steps',
    value: 'Steps'

}, {

    key: 'Strand',
    value: 'Strand'

}, {

    key: 'Street',
    value: 'Street'

}, {

    key: 'Strip',
    value: 'Strip'

}, {

    key: 'Subway',
    value: 'Subway'

}, {

    key: 'Tarn',
    value: 'Tarn'

}, {

    key: 'Terrace',
    value: 'Terrace'

}, {

    key: 'Thoroughfare',
    value: 'Thoroughfare'

}, {

    key: 'Tollway',
    value: 'Tollway'

}, {

    key: 'Top',
    value: 'Top'

}, {

    key: 'Tor',
    value: 'Tor'

}, {

    key: 'Towers',
    value: 'Towers'

}, {

    key: 'Track',
    value: 'Track'

}, {

    key: 'Trail',
    value: 'Trail'

}, {

    key: 'Trailer',
    value: 'Trailer'

}, {

    key: 'Triangle',
    value: 'Triangle'

}, {

    key: 'Trunkway',
    value: 'Trunkway'

}, {

    key: 'Turn',
    value: 'Turn'

}, {

    key: 'Underpass',
    value: 'Underpass'

}, {

    key: 'Upper',
    value: 'Upper'

}, {

    key: 'Vale',
    value: 'Vale'

}, {

    key: 'Viaduct',
    value: 'Viaduct'

}, {

    key: 'View',
    value: 'View'

}, {

    key: 'Villas',
    value: 'Villas'

}, {

    key: 'Vista',
    value: 'Vista'

}, {

    key: 'Wade',
    value: 'Wade'

}, {

    key: 'Walk',
    value: 'Walk'

}, {

    key: 'Walkway',
    value: 'Walkway'

}, {

    key: 'Waters',
    value: 'Waters'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Wharf',
    value: 'Wharf'

}, {

    key: 'Wood',
    value: 'Wood'

}, {

    key: 'Wynd',
    value: 'Wynd'

}, {

    key: 'Yard',
    value: 'Yard'

}, {

    key: 'Access',
    value: 'Access'

}, {

    key: 'Alley',
    value: 'Alley'

}, {

    key: 'Alleyway',
    value: 'Alleyway'

}, {

    key: 'Amble',
    value: 'Amble'

}, {

    key: 'Anchorage',
    value: 'Anchorage'

}, {

    key: 'Approach',
    value: 'Approach'

}, {

    key: 'Arcade',
    value: 'Arcade'

}, {

    key: 'Artery',
    value: 'Artery'

}, {

    key: 'Avenue',
    value: 'Avenue'

}, {

    key: 'Basin',
    value: 'Basin'

}, {

    key: 'Bank',
    value: 'Bank'

}, {

    key: 'Bay',
    value: 'Bay'

}, {

    key: 'Beach',
    value: 'Beach'

}, {

    key: 'Bend',
    value: 'Bend'

}, {

    key: 'Block',
    value: 'Block'

}, {

    key: 'Boundary',
    value: 'Boundary'

}, {

    key: 'Bowl',
    value: 'Bowl'

}, {

    key: 'Boulevard',
    value: 'Boulevard'

}, {

    key: 'Brace',
    value: 'Brace'

}, {

    key: 'Branch',
    value: 'Branch'

}, {

    key: 'Brae',
    value: 'Brae'

}, {

    key: 'Break',
    value: 'Break'

}, {

    key: 'Bridge',
    value: 'Bridge'

}, {

    key: 'Broadway',
    value: 'Broadway'

}, {

    key: 'Brow',
    value: 'Brow'

}, {

    key: 'Bypass',
    value: 'Bypass'

}, {

    key: 'Byway',
    value: 'Byway'

}, {

    key: 'Causeway',
    value: 'Causeway'

}, {

    key: 'Centre',
    value: 'Centre'

}, {

    key: 'Centreway',
    value: 'Centreway'

}, {

    key: 'Chase',
    value: 'Chase'

}, {

    key: 'Circle',
    value: 'Circle'

}, {

    key: 'Circlet',
    value: 'Circlet'

}, {

    key: 'Circuit',
    value: 'Circuit'

}, {

    key: 'Circus',
    value: 'Circus'

}, {

    key: 'Close',
    value: 'Close'

}, {

    key: 'Colonnade',
    value: 'Colonnade'

}, {

    key: 'Common',
    value: 'Common'

}, {

    key: 'Concourse',
    value: 'Concourse'

}, {

    key: 'Copse',
    value: 'Copse'

}, {

    key: 'Corner',
    value: 'Corner'

}, {

    key: 'Corso',
    value: 'Corso'

}, {

    key: 'Court',
    value: 'Court'

}, {

    key: 'Course',
    value: 'Course'

}, {

    key: 'Courtyard',
    value: 'Courtyard'

}, {

    key: 'Cove',
    value: 'Cove'

}, {

    key: 'Crescent',
    value: 'Crescent'

}, {

    key: 'Crest',
    value: 'Crest'

}, {

    key: 'Creek',
    value: 'Creek'

}, {

    key: 'Cross',
    value: 'Cross'

}, {

    key: 'Crossing',
    value: 'Crossing'

}, {

    key: 'Crossroad',
    value: 'Crossroad'

}, {

    key: 'Crossway',
    value: 'Crossway'

}, {

    key: 'Crief',
    value: 'Crief'

}, {

    key: 'Cruiseway',
    value: 'Cruiseway'

}, {

    key: 'Cul-de-sac',
    value: 'Cul-de-sac'

}, {

    key: 'Cutting',
    value: 'Cutting'

}, {

    key: 'Dale',
    value: 'Dale'

}, {

    key: 'Dell',
    value: 'Dell'

}, {

    key: 'Deviation',
    value: 'Deviation'

}, {

    key: 'Dip',
    value: 'Dip'

}, {

    key: 'Distributor',
    value: 'Distributor'

}, {

    key: 'Downs',
    value: 'Downs'

}, {

    key: 'Drive',
    value: 'Drive'

}, {

    key: 'Driveway',
    value: 'Driveway'

}, {

    key: 'Easement',
    value: 'Easement'

}, {

    key: 'Edge',
    value: 'Edge'

}, {

    key: 'Elbow',
    value: 'Elbow'

}, {

    key: 'End',
    value: 'End'

}, {

    key: 'Entrance',
    value: 'Entrance'

}, {

    key: 'Esplanade',
    value: 'Esplanade'

}, {

    key: 'Estate',
    value: 'Estate'

}, {

    key: 'Expressway',
    value: 'Expressway'

}, {

    key: 'Extension',
    value: 'Extension'

}, {

    key: 'Fairway',
    value: 'Fairway'

}, {

    key: 'Fire',
    value: 'Fire'

}, {

    key: 'track',
    value: 'track'

}, {

    key: 'Firetrail',
    value: 'Firetrail'

}, {

    key: 'Flat',
    value: 'Flat'

}, {

    key: 'Follow',
    value: 'Follow'

}, {

    key: 'Footway',
    value: 'Footway'

}, {

    key: 'Foreshore',
    value: 'Foreshore'

}, {

    key: 'Formation',
    value: 'Formation'

}, {

    key: 'Freeway',
    value: 'Freeway'

}, {

    key: 'Front',
    value: 'Front'

}, {

    key: 'Frontage',
    value: 'Frontage'

}, {

    key: 'Gap',
    value: 'Gap'

}, {

    key: 'Garden',
    value: 'Garden'

}, {

    key: 'Gardens',
    value: 'Gardens'

}, {

    key: 'Gate',
    value: 'Gate'

}, {

    key: 'Gateway',
    value: 'Gateway'

}, {

    key: 'Gates',
    value: 'Gates'

}, {

    key: 'Glade',
    value: 'Glade'

}, {

    key: 'Glen',
    value: 'Glen'

}, {

    key: 'Grange',
    value: 'Grange'

}, {

    key: 'Green',
    value: 'Green'

}, {

    key: 'Ground',
    value: 'Ground'

}, {

    key: 'Grove',
    value: 'Grove'

}, {

    key: 'Gully',
    value: 'Gully'

}, {

    key: 'Heath',
    value: 'Heath'

}, {

    key: 'Heights',
    value: 'Heights'

}, {

    key: 'Highroad',
    value: 'Highroad'

}, {

    key: 'Highway',
    value: 'Highway'

}, {

    key: 'Hill',
    value: 'Hill'

}, {

    key: 'Interchange',
    value: 'Interchange'

}, {

    key: 'Intersection',
    value: 'Intersection'

}, {

    key: 'Junction',
    value: 'Junction'

}, {

    key: 'Landing',
    value: 'Landing'

}, {

    key: 'Lane',
    value: 'Lane'

}, {

    key: 'Laneway',
    value: 'Laneway'

}, {

    key: 'Lees',
    value: 'Lees'

}, {

    key: 'Line',
    value: 'Line'

}, {

    key: 'Link',
    value: 'Link'

}, {

    key: 'Little',
    value: 'Little'

}, {

    key: 'Location',
    value: 'Location'

}, {

    key: 'Lookout',
    value: 'Lookout'

}, {

    key: 'Loop',
    value: 'Loop'

}, {

    key: 'Lower',
    value: 'Lower'

}, {

    key: 'Mall',
    value: 'Mall'

}, {

    key: 'Meander',
    value: 'Meander'

}, {

    key: 'Mew',
    value: 'Mew'

}, {

    key: 'Mews',
    value: 'Mews'

}, {

    key: 'Motorway',
    value: 'Motorway'

}, {

    key: 'Mount',
    value: 'Mount'

}, {

    key: 'Nook',
    value: 'Nook'

}, {

    key: 'Outlook',
    value: 'Outlook'

}, {

    key: 'Parade',
    value: 'Parade'

}, {

    key: 'Park',
    value: 'Park'

}, {

    key: 'Parklands',
    value: 'Parklands'

}, {

    key: 'Parkway',
    value: 'Parkway'

}, {

    key: 'Part',
    value: 'Part'

}, {

    key: 'Pass',
    value: 'Pass'

}, {

    key: 'Path',
    value: 'Path'

}, {

    key: 'Pathway',
    value: 'Pathway'

}, {

    key: 'Piazza',
    value: 'Piazza'

}, {

    key: 'Pier',
    value: 'Pier'

}, {

    key: 'Place',
    value: 'Place'

}, {

    key: 'Plateau',
    value: 'Plateau'

}, {

    key: 'Plaza',
    value: 'Plaza'

}, {

    key: 'Pocket',
    value: 'Pocket'

}, {

    key: 'Point',
    value: 'Point'

}, {

    key: 'Port',
    value: 'Port'

}, {

    key: 'Promenade',
    value: 'Promenade'

}, {

    key: 'Pursuit',
    value: 'Pursuit'

}, {

    key: 'Quad',
    value: 'Quad'

}, {

    key: 'Quadrangle',
    value: 'Quadrangle'

}, {

    key: 'Quadrant',
    value: 'Quadrant'

}, {

    key: 'Quay',
    value: 'Quay'

}, {

    key: 'Quays',
    value: 'Quays'

}, {

    key: 'Railway',
    value: 'Railway'

}, {

    key: 'Siding',
    value: 'Siding'

}, {

    key: 'Ramble',
    value: 'Ramble'

}, {

    key: 'Ramp',
    value: 'Ramp'

}, {

    key: 'Range',
    value: 'Range'

}, {

    key: 'Reach',
    value: 'Reach'

}, {

    key: 'Reserve',
    value: 'Reserve'

}, {

    key: 'Rest',
    value: 'Rest'

}, {

    key: 'Retreat',
    value: 'Retreat'

}, {

    key: 'Return',
    value: 'Return'

}, {

    key: 'Ride',
    value: 'Ride'

}, {

    key: 'Ridge',
    value: 'Ridge'

}, {

    key: 'Ridgeway',
    value: 'Ridgeway'

}, {

    key: 'Right',
    value: 'Right'

}, {

    key: 'of',
    value: 'of'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Ring',
    value: 'Ring'

}, {

    key: 'Rise',
    value: 'Rise'

}, {

    key: 'River',
    value: 'River'

}, {

    key: 'Riverway',
    value: 'Riverway'

}, {

    key: 'Riviera',
    value: 'Riviera'

}, {

    key: 'Road',
    value: 'Road'

}, {

    key: 'Roads',
    value: 'Roads'

}, {

    key: 'Roadside',
    value: 'Roadside'

}, {

    key: 'Roadway',
    value: 'Roadway'

}, {

    key: 'Ronde',
    value: 'Ronde'

}, {

    key: 'Rosebowl',
    value: 'Rosebowl'

}, {

    key: 'Rotary',
    value: 'Rotary'

}, {

    key: 'Round',
    value: 'Round'

}, {

    key: 'Route',
    value: 'Route'

}, {

    key: 'Row',
    value: 'Row'

}, {

    key: 'Rue',
    value: 'Rue'

}, {

    key: 'Run',
    value: 'Run'

}, {

    key: 'Service',
    value: 'Service'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Siding',
    value: 'Siding'

}, {

    key: 'Slope',
    value: 'Slope'

}, {

    key: 'Sound',
    value: 'Sound'

}, {

    key: 'Spur',
    value: 'Spur'

}, {

    key: 'Square',
    value: 'Square'

}, {

    key: 'Stairs',
    value: 'Stairs'

}, {

    key: 'State',
    value: 'State'

}, {

    key: 'Highway',
    value: 'Highway'

}, {

    key: 'Steps',
    value: 'Steps'

}, {

    key: 'Strand',
    value: 'Strand'

}, {

    key: 'Street',
    value: 'Street'

}, {

    key: 'Strip',
    value: 'Strip'

}, {

    key: 'Subway',
    value: 'Subway'

}, {

    key: 'Tarn',
    value: 'Tarn'

}, {

    key: 'Terrace',
    value: 'Terrace'

}, {

    key: 'Thoroughfare',
    value: 'Thoroughfare'

}, {

    key: 'Tollway',
    value: 'Tollway'

}, {

    key: 'Top',
    value: 'Top'

}, {

    key: 'Tor',
    value: 'Tor'

}, {

    key: 'Towers',
    value: 'Towers'

}, {

    key: 'Track',
    value: 'Track'

}, {

    key: 'Trail',
    value: 'Trail'

}, {

    key: 'Trailer',
    value: 'Trailer'

}, {

    key: 'Triangle',
    value: 'Triangle'

}, {

    key: 'Trunkway',
    value: 'Trunkway'

}, {

    key: 'Turn',
    value: 'Turn'

}, {

    key: 'Underpass',
    value: 'Underpass'

}, {

    key: 'Upper',
    value: 'Upper'

}, {

    key: 'Vale',
    value: 'Vale'

}, {

    key: 'Viaduct',
    value: 'Viaduct'

}, {

    key: 'View',
    value: 'View'

}, {

    key: 'Villas',
    value: 'Villas'

}, {

    key: 'Vista',
    value: 'Vista'

}, {

    key: 'Wade',
    value: 'Wade'

}, {

    key: 'Walk',
    value: 'Walk'

}, {

    key: 'Walkway',
    value: 'Walkway'

}, {

    key: 'Waters',
    value: 'Waters'

}, {

    key: 'Way',
    value: 'Way'

}, {

    key: 'Wharf',
    value: 'Wharf'

}, {

    key: 'Wood',
    value: 'Wood'

}, {

    key: 'Wynd',
    value: 'Wynd'

}, {

    key: 'Yard',
    value: 'Yard'
}

]
export const messageBankModalContent = {
    changeToVoiceMessageBank: {
        header: 'Change to Voice MessageBank®?',
        bodyContent: [
            {
                value: 'Any saved messages for your current voicemail service will be deleted.',
                isBold: false
            }],
        size: 'medium',
        link: false,
        cancel: 'Cancel',
        enable: 'Yes, change'
    },
    disableMessageBank: {
        header: 'Disable MessageBank®?',
        bodyContent: [{
            value: 'By disabling MessageBank® any messages that have been saved will be deleted.',
            isBold: false
        }],
        size: 'small',
        link: false,
        cancel: 'Cancel',
        enable: 'Yes, disable'
    },
    enableVideoMessageBank: {
        header: 'Enable Video MessageBank® ?',
        bodyContent: [{
            value: 'Video MessageBank® requires data. Data barring also needs to be removed.',
            isBold: true
        },
        {
            value: 'For Video MessageBank® to work, this service needs data access. If this service is not on a plan,'
                + 'pay-as-you-go data rates may apply.',
            isBold: false
        },
        {
            value: 'If data barring is enabled on this service, we will remove it so that Video MessageBank® can work.',
            isBold: false
        },
        {
            value: 'To curb high mobile data usage, turn off mobile data in the phone’s settings.',
            isBold: false
        }],
        radioOptionsHeading: 'What would you like to do?',
        radioButtonOptionFastChange: 'Enable Video MessageBank® and remove any data barring',
        radioButtonOptionMaximChange: 'Enable Video MessageBank®, remove any data barring and request help with'
            + ' mobile or data plan options',
        checkboxContent: 'I agree to data being used for this service and any pay-as-you-go charges that may occur.',
        link: true,
        cancel: 'Cancel',
        enable: 'Proceed to enable',
        size: 'large'
    },
    changeToVideoMessageBank: {
        header: 'Change to Video MessageBank®?',
        bodyContent: [
            {
                value: 'Any saved messages for your current voicemail service will be deleted.',
                isBold: false
            },
            {
                value: 'Video MessageBank® requires data. Data barring also needs to be removed.',
                isBold: true
            },
            {
                value: 'For Video MessageBank® to work, this service needs data access. If this '
                    + 'service is not on a plan, pay-as-you-go data rates may apply.',
                isBold: false
            },
            {
                value: `If data barring is enabled on this service, we will remove it so that
                 Video MessageBank® can work.`,
                isBold: false
            },
            { value: 'To curb high mobile data usage, turn off mobile data in the phone’s settings.', isBold: false }],
        radioOptionsHeading: 'What would you like to do?',
        radioButtonOptionFastChange: 'Enable Video MessageBank® and remove any data barring',
        radioButtonOptionMaximChange: 'Enable Video MessageBank®, remove any data barring and request help with'
            + ' mobile or data plan options',
        link: true,
        checkboxContent: 'I agree to data being used for this service and any pay-as-you-go charges that may occur.',
        cancel: 'Cancel',
        enable: 'Yes, change',
        size: 'large'
    },
    stpWarningText: 'Before proceeding with this change, remember: If this service is not on a plan, pay-as-you-go'
        + ' data charges may apply.',
    radioButtonSelectionErrorMessage: 'You must select an option to continue',
    userAgreementCheckErrorMessage: 'You must agree to this to continue'
}

export const maximFormConfigObject = {
    voice2TextMessageBank: {
        questionsHeader: 'Leave your details below and we\'ll contact you about options if needed:'
    },
    changeToVideoMessageBank: {
        questionsHeader: 'Leave your details below and we\'ll contact you about mobile or data plan options.'
    },
    enableVideoMessageBank: {
        questionsHeader: 'Leave your details below and we\'ll contact you about mobile or data plan options.'
    }
}

export const tonCatalogObject = {
    pairDeviceInfo: `When a subscription is activated by the end user,  a $5 ex GST monthly charge will
     apply to your next invoice.`,
    alreadypairedDeviceInfo: `This service currently has an active Telstra One Number subscription,
     which is $5 ex GST per month.`,
    moreInformationOnPairOld: 'More information such as how to pair a device after you subscribe to TON can be found ',
    moreInformationOnAlreadyPairedOld: 'More information on subscription and pairing can be found ',
    pairDeviceInfoOld: `Once a device is paired by the end user,
     a $5 per month will start being charged to your account.`,
    alreadypairedDeviceInfoOld: `There is currently a device paired and a monthly charge of $5 per month
     is on the account.`,
    moreInformationOnPair: 'More information such as how to pair a device after you subscribe to TON,can be found ',
    moreInformationOnAlreadyPaired: 'More information on subscription and pairing can be found ',

    moreInformationUrl: 'https://www.telstra.com.au/small-business/online-support/mobiles-devices/telstra-one-number',
    questionObject: [
        {
            name: 'subscription_status',
            questionText: 'Subscription status',
            isQuestionMandatory: false,
            questionFormat: 'Label'
        },
        {
            name: 'smart_watch_paired',
            questionText: 'Smart watch paired',
            isQuestionMandatory: false,
            questionFormat: 'Label'
        },
        {
            name: 'update_the_telstra_one_number_subscription',
            questionText: 'Action:',
            isQuestionMandatory: true,
            questionFormat: 'Multiple Choice',
            answers: [
                {
                    key: 'unsubscribe_unpair',
                    value: 'Unsubscribe to TON and unpair devices'
                },
                {
                    key: 'unpair_the_currently_connected_smart_watch',
                    value: 'Unpair the currently connected device but keep subscription to TON'
                }
            ]
        },
        {
            name: 'update_the_telstra_one_number_subscription_subscribe',
            questionText: 'Subscribe to TON for the above service',
            isQuestionMandatory: true,
            questionFormat: 'CheckBox'
        },
        {
            name: 'update_the_telstra_one_number_subscription_unsubscribe',
            questionText: 'Unsubscribe to TON for the above service',
            isQuestionMandatory: true,
            questionFormat: 'CheckBox'
        }
    ],

    questionObjectTON: [
        {
            name: 'subscription_status',
            questionText: 'Access to subscribe',
            isQuestionMandatory: false,
            questionFormat: 'Label'
        },
        {
            name: 'smart_watch_paired',
            questionText: 'Subscription status',
            isQuestionMandatory: false,
            questionFormat: 'Label'
        },
        {
            name: 'update_the_telstra_one_number_subscription',
            questionText: 'Action:',
            isQuestionMandatory: true,
            questionFormat: 'Multiple Choice',
            answers: [
                {
                    key: 'unsubscribe_unpair',
                    value: 'Bar Telstra One Number from being activated on this mobile service'
                },
                {
                    key: 'unpair_the_currently_connected_smart_watch',
                    value: 'Deactivate subscription'
                }
            ]
        },
        {
            name: 'update_the_telstra_one_number_subscription_inactive',
            questionText: 'Action:',
            isQuestionMandatory: true,
            questionFormat: 'Multiple Choice',
            answers: [
                {
                    key: 'unsubscribe_unpair',
                    value: 'Bar Telstra One Number from being activated on this mobile service'
                }
            ]
        },
        {
            name: 'update_the_telstra_one_number_subscription_subscribe',
            questionText: 'Subscribe to TON for the above service',
            isQuestionMandatory: true,
            questionFormat: 'CheckBox'
        },
        {
            name: 'update_the_telstra_one_number_subscription_unsubscribe',
            questionText: 'Unbar Telstra One number',
            isQuestionMandatory: true,
            questionFormat: 'CheckBox'
        }
    ],
    propsToPick: ['questionText', 'questionFormat', 'answers'],
    unsubscribe_unpair_first: `The current subscription will be deactivated and the $5 ex GST monthly charge will stop
     on your next invoice.`,
    unsubscribe_unpair_second: `You'll need to unbar Telstra One Number on this service to allow it to be reactivated
     on this mobile number in the future.`,
    unpair_the_currently_connected_smart_watch_first: `The current subscription will be deactivated and the $5 ex GST
     monthly charge will stop on your next invoice. Testra One Number will still be available on this service.`,
    unsubscribe_unpair_first_old: `This user’s smart watch will be unpaired from their mobile number and the $5 monthly
     billing for this add-on will stop.`,
    unsubscribe_unpair_second_old: `To pair a smart watch in the future, a Telstra One
     Number subscription will first need to be reinstated.`,
    unpair_the_currently_connected_smart_watch_first_old: `This user’s smart watch will be
     unpaired from their mobile number
     and the $5 monthly billing for this add-on will stop until the user pairs a smart watch again.`,

    subscriptionFailureMessage: `We could not load the Telstra One Number subscription or smart watch pairing
     status for this mobile number.`,
    tryAgainText: 'Please try again',
    subscriptionLabel: 'Subscription status:',
    tryAgainExtraText: 'If that does not work, please try again later.',
    mobileNoAssistiveText: 'Start the mobile number search with 614.',
    tonAssistiveText: 'Start the search with 614.',
    radioMessageOne: `The current subscription will be deactivated and the $5 ex GST monthly charge
     will stop on your next invoice.
     You'll need to unbar Telstra One Number on this service to allow it to be reactivated on this
      mobile number in the future.`,
    radioMessageTwo: `The current subscription will be deactivated and the $5 ex GST monthly charge will
     stop on your next invoice. Testra One Number will still be available on this service.`,
    radioMessageThree: `You'll need to unbar Telstra One Number on this service to allow it to be activated
     on this mobile number in the future.`
}

export const hardwarePayoutCatalogObject = {
    loadingLabel: 'Early Termination Charge',
    etcFailureMessage: `We could not load the Early Termination Charge for your service.`,
    tryAgainText: 'Please try again',
    imeiNoAssistiveText: `The unique identifier for the hardware: an IMEI number or serial number.
    The IMEI for a mobile device can be found by dialling *#06#.`,
    etcInfoText: (amount: string) => `This item is subject to an Early Termination Charge.
    If you select to pay out this item today, you will be charged an estimated ${amount}
    including GST for the device selected.`,
    searchText: 'IMEI (device ID)',
    imeiInfoFirst: 'The unique identifier for the hardware: an IMEI number or serial number.',
    imeiInfoSecond: 'The IMEI for a mobile device can be found by dialling *#06#.'
}

export const mobilePlans = [
    {
        name: 'Mobile Essential Plan',
        plan: 'Essential',
        planType: 'Mobile',
        generalDetails: '$55/mth \n 40GB shared data \n 50MBps speed cap'
    },
    {
        name: 'Mobile Enhanced Plan',
        plan: 'Enhanced',
        planType: 'Mobile',
        generalDetails: '$65/mth \n 80GB shared data \n 250MBps speed cap'
    },
    {
        name: 'Mobile Epic Plan',
        plan: 'Epic',
        planType: 'Mobile',
        generalDetails: '$75/mth \n  120GB shared data \n No speed cap'
    },
    {
        name: 'Mobile Broadband Essential Plan',
        plan: 'Essential',
        planType: 'Mobile Broadband',
        generalDetails: '$20/mth \n 10GB shared data \n 50MBps speed cap'
    },
    {
        name: 'Mobile Broadband Enhanced Plan',
        plan: 'Enhanced',
        planType: 'Mobile Broadband',
        generalDetails: '$35/mth \n 30GB shared data \n 250MBps speed cap'
    },
    {
        name: 'Mobile Broadband Epic Plan',
        plan: 'Epic',
        planType: 'Mobile Broadband',
        generalDetails: '$50/mth \n 50GB shared data \n No speed cap'
    },
    {
        name: 'Enterprise Wireless Essential Plan',
        plan: 'Essential',
        planType: 'Enterprise Wireless',
        generalDetails: '$20/mth \n 100MB shared data \n 100MBps speed cap'
    },
    {
        name: 'Enterprise Wireless Enhanced Plan',
        plan: 'Enhanced',
        planType: 'Enterprise Wireless',
        generalDetails: '$30/mth \n 100MB shared data \n 250MBps speed cap'
    },
    {
        name: 'Enterprise Wireless Epic Plan',
        plan: 'Epic',
        planType: 'Enterprise Wireless',
        generalDetails: '$50/mth \n 50GB shared data \n No speed cap'
    },
    {
        name: 'Enterprise Wireless Essential Non-Shared Plan',
        plan: 'Essential Non-Shared',
        planType: 'Enterprise Wireless',
        generalDetails: '$20/mth \n 100MB non-shared data \n 100MBps speed cap'
    },
    {
        name: 'Enterprise Wireless Enhanced Non-Shared Plan',
        plan: 'Enhanced Non-Shared',
        planType: 'Enterprise Wireless',
        generalDetails: '$30/mth \n 100MB non-shared data \n 250MBps speed cap'
    },
    {
        name: 'Enterprise Wireless Epic Non-Shared Plan',
        plan: 'Epic Non-Shared',
        planType: 'Enterprise Wireless',
        generalDetails: '$50/mth \n 50GB non-shared data \n No speed cap'
    }
];

export const adapiveMobilePlansWithExecutive = [
    {
        name: 'Mobile Essential Plan',
        plan: 'Essential',
        planType: 'Mobile',
        generalDetails: '$58/mth, 50GB shared data, No speed cap'
    },
    {
        name: 'Mobile Enhanced Plan',
        plan: 'Enhanced',
        planType: 'Mobile',
        generalDetails: '$63/mth, 100GB shared data, No speed cap'
    },
    {
        name: 'Mobile Epic Plan',
        plan: 'Epic',
        planType: 'Mobile',
        generalDetails: '$80/mth, 150GB shared data, No speed cap'
    },
    {
        name: 'Mobile Executive Plan',
        plan: 'Executive',
        planType: 'Mobile',
        generalDetails: '$120/mth, 200GB shared data, No speed cap'
    },
    {
        name: 'Mobile Broadband Essential Plan',
        plan: 'Essential',
        planType: 'Mobile Broadband',
        generalDetails: '$23/mth, 15GB shared data, No speed cap'
    },
    {
        name: 'Mobile Broadband Enhanced Plan',
        plan: 'Enhanced',
        planType: 'Mobile Broadband',
        generalDetails: '$40/mth, 40GB shared data, No speed cap'
    },
    {
        name: 'Mobile Broadband Epic Plan',
        plan: 'Epic',
        planType: 'Mobile Broadband',
        generalDetails: '$60/mth, 80GB shared data, No speed cap'
    },
    {
        name: 'Enterprise Wireless Enhanced Plan',
        plan: 'Enhanced',
        planType: 'Enterprise Wireless',
        generalDetails: '$30/mth, 100MB shared data, No speed cap'
    },
    {
        name: 'Enterprise Wireless Essential Plan',
        plan: 'Essential',
        planType: 'Enterprise Wireless',
        generalDetails: '$20/mth, 100MB shared data, No speed cap'
    },
    {
        name: 'Enterprise Wireless Epic Plan',
        plan: 'Epic',
        planType: 'Enterprise Wireless',
        generalDetails: '$50/mth, 50GB shared data, No speed cap'
    },
    {
        name: 'Enterprise Wireless Essential Non-Shared Plan',
        plan: 'Essential Non-Shared',
        planType: 'Enterprise Wireless',
        generalDetails: '$20/mth, 100MB non-shared data, No speed cap'
    },
    {
        name: 'Enterprise Wireless Enhanced Non-Shared Plan',
        plan: 'Enhanced Non-Shared',
        planType: 'Enterprise Wireless',
        generalDetails: '$30/mth, 100MB non-shared data, No speed cap'
    },
    {
        name: 'Enterprise Wireless Epic Non-Shared Plan',
        plan: 'Epic Non-Shared',
        planType: 'Enterprise Wireless',
        generalDetails: '$50/mth, 50GB non-shared data, No speed cap'
    }
];

export const refreshedAdaptiveMobilityPlans = [
    {
        name: 'Mobile Essential Plan',
        plan: 'Essential',
        planType: 'Mobile',
        generalDetails: '$63/mth, 50GB shared data, No speed cap'
    },
    {
        name: 'Mobile Enhanced Plan',
        plan: 'Enhanced',
        planType: 'Mobile',
        generalDetails: '$68/mth, 100GB shared data, No speed cap'
    },
    {
        name: 'Mobile Epic Plan',
        plan: 'Epic',
        planType: 'Mobile',
        generalDetails: '$85/mth, 150GB shared data, No speed cap'
    },
    {
        name: 'Mobile Executive Plan',
        plan: 'Executive',
        planType: 'Mobile',
        generalDetails: '$120/mth, 200GB shared data, No speed cap'
    },
    {
        name: 'Mobile Broadband Essential Plan',
        plan: 'Essential',
        planType: 'Mobile Broadband',
        generalDetails: '$26/mth, 15GB shared data, No speed cap'
    },
    {
        name: 'Mobile Broadband Enhanced Plan',
        plan: 'Enhanced',
        planType: 'Mobile Broadband',
        generalDetails: '$40/mth, 40GB shared data, No speed cap'
    },
    {
        name: 'Mobile Broadband Epic Plan',
        plan: 'Epic',
        planType: 'Mobile Broadband',
        generalDetails: '$60/mth, 80GB shared data, No speed cap'
    },
    {
        name: 'Enterprise Wireless Enhanced Plan',
        plan: 'Enhanced',
        planType: 'Enterprise Wireless',
        generalDetails: '$30/mth, 100MB shared data, No speed cap'
    },
    {
        name: 'Enterprise Wireless Essential Plan',
        plan: 'Essential',
        planType: 'Enterprise Wireless',
        generalDetails: '$20/mth, 100MB shared data, No speed cap'
    },
    {
        name: 'Enterprise Wireless Epic Plan',
        plan: 'Epic',
        planType: 'Enterprise Wireless',
        generalDetails: '$50/mth, 50GB shared data, No speed cap'
    },
    {
        name: 'Enterprise Wireless Essential Non-Shared Plan',
        plan: 'Essential Non-Shared',
        planType: 'Enterprise Wireless',
        generalDetails: '$20/mth, 100MB non-shared data, No speed cap'
    },
    {
        name: 'Enterprise Wireless Enhanced Non-Shared Plan',
        plan: 'Enhanced Non-Shared',
        planType: 'Enterprise Wireless',
        generalDetails: '$30/mth, 100MB non-shared data, No speed cap'
    },
    {
        name: 'Enterprise Wireless Epic Non-Shared Plan',
        plan: 'Epic Non-Shared',
        planType: 'Enterprise Wireless',
        generalDetails: '$50/mth, 50GB non-shared data, No speed cap'
    }
];

export const changeAdaptiveMobilityPlan = {
    planTitle: 'Plan',
    generalDetailsTitle: 'General details',
    discountedChargeTitle: 'Discounted charges',
    currentGeneralDetails: (plan: string, planType: string) => {
        const itemObj = mobilePlans.filter((item) => {
            const updatedPlanType = planType === 'Handheld' ? 'Mobile' : planType
            return item.plan === plan && item.planType === updatedPlanType;
        });
        return (itemObj && itemObj.length > 0) ? itemObj[0].generalDetails : 'NA';
    },
    generalDetails: (planName: string) => {
        const itemObj = mobilePlans.filter((item) => {
            return item.name.toLowerCase() === planName.toLowerCase();
        });
        return (itemObj && itemObj.length > 0) ? itemObj[0].generalDetails : 'NA';
    },
    plan: (planName: string) => {
        const itemObj = mobilePlans.filter((item) => {
            return item.name.toLowerCase() === planName.toLowerCase();
        });
        return (itemObj && itemObj.length > 0) ? itemObj[0].plan : 'NA';
    },
    planType: (planName: string) => {
        const itemObj = mobilePlans.filter((item) => {
            return item.name.toLowerCase() === planName.toLowerCase();
        });
        return (itemObj && itemObj.length > 0) ? itemObj[0].planType : 'NA';
    },
    footer: `All charges include GST. Shared data is where a monthly Mobile / Mobile
    Broadband / Enterprise data allowance is pooled and shared with other mobile
    services that are under the same plan type and the same billing account. ` +
        `\n For full details see the `,
    footerWithoutLink: `All charges include GST. Shared data is where a monthly Mobile / Mobile
    Broadband / Enterprise data allowance is pooled and shared with other mobile
    services that are under the same plan type and the same billing account.`,
    errorHandling: `Your monthly charges will either be the same as those listed
    in the general details above, or less if you are eligible for a discount. `,
    introTextSecondPara: 'This change applies once this request is submitted.',
    introTextThirdPara: `Billing changes take effect from the first day of the next month
    (pro rata charges do not apply).`
}

export const changeAdaptiveMobilityPlanExecutive = {
    planTitle: 'Plan',
    generalDetailsTitle: 'General details',
    discountedChargeTitle: 'Discounted charges',
    currentGeneralDetails: (plan: string, planType: string) => {
        const itemObj = adapiveMobilePlansWithExecutive.filter((item) => {
            const updatedPlanType = planType === 'Handheld' ? 'Mobile' : planType
            return item.plan === plan && item.planType === updatedPlanType;
        });
        return (itemObj && itemObj.length > 0) ? itemObj[0].generalDetails : 'NA';
    },
    generalDetails: (planName: string) => {
        const itemObj = adapiveMobilePlansWithExecutive.filter((item) => {
            return item.name.toLowerCase() === planName.toLowerCase();
        });
        return (itemObj && itemObj.length > 0) ? itemObj[0].generalDetails : 'NA';
    },
    plan: (planName: string) => {
        const itemObj = adapiveMobilePlansWithExecutive.filter((item) => {
            return item.name.toLowerCase() === planName.toLowerCase();
        });
        return (itemObj && itemObj.length > 0) ? itemObj[0].plan : 'NA';
    },
    planType: (planName: string) => {
        const itemObj = adapiveMobilePlansWithExecutive.filter((item) => {
            return item.name.toLowerCase() === planName.toLowerCase();
        });
        return (itemObj && itemObj.length > 0) ? itemObj[0].planType : 'NA';
    },
    footer: `All charges include GST. Shared data is where a monthly Mobile / Mobile
    Broadband / Enterprise data allowance is pooled and shared with other mobile
    services that are under the same plan type and the same billing account. ` +
        `\n For full details see the `,
    footerWithoutLink: `All charges include GST. Shared data is where a monthly Mobile / Mobile
    Broadband / Enterprise data allowance is pooled and shared with other mobile
    services that are under the same plan type and the same billing account.`,
    errorHandling: `Your monthly charges will either be the same as those listed
    in the general details above, or less if you are eligible for a discount. `,
    introTextSecondPara: 'This change applies once this request is submitted.',
    introTextThirdPara: `Billing changes take effect from the first day of the next month
    (pro rata charges do not apply).`
}

export const updatedChangeAdaptiveMobilityPlanExecutive = {
    planTitle: 'Plan',
    generalDetailsTitle: 'General details',
    discountedChargeTitle: 'Discounted charges',
    currentGeneralDetails: (plan: string, planType: string) => {
        const itemObj = refreshedAdaptiveMobilityPlans.filter((item) => {
            const updatedPlanType = planType === 'Handheld' ? 'Mobile' : planType
            return item.plan === plan && item.planType === updatedPlanType;
        });
        return (itemObj && itemObj.length > 0) ? itemObj[0].generalDetails : 'NA';
    },
    generalDetails: (planName: string) => {
        const itemObj = refreshedAdaptiveMobilityPlans.filter((item) => {
            return item.name.toLowerCase() === planName.toLowerCase();
        });
        return (itemObj && itemObj.length > 0) ? itemObj[0].generalDetails : 'NA';
    },
    plan: (planName: string) => {
        const itemObj = refreshedAdaptiveMobilityPlans.filter((item) => {
            return item.name.toLowerCase() === planName.toLowerCase();
        });
        return (itemObj && itemObj.length > 0) ? itemObj[0].plan : 'NA';
    },
    planType: (planName: string) => {
        const itemObj = refreshedAdaptiveMobilityPlans.filter((item) => {
            return item.name.toLowerCase() === planName.toLowerCase();
        });
        return (itemObj && itemObj.length > 0) ? itemObj[0].planType : 'NA';
    },
    footer: `All charges include GST. Shared data is where a monthly Mobile / Mobile
    Broadband / Enterprise data allowance is pooled and shared with other mobile
    services that are under the same plan type and the same billing account. ` +
        `\n For full details see the `,
    footerWithoutLink: `All charges include GST. Shared data is where a monthly Mobile / Mobile
    Broadband / Enterprise data allowance is pooled and shared with other mobile
    services that are under the same plan type and the same billing account.`,
    errorHandling: `Your monthly charges will either be the same as those listed
    in the general details above, or less if you are eligible for a discount. `,
    introTextSecondPara: 'This change applies once this request is submitted.',
    introTextThirdPara: `Billing changes take effect from the first day of the next month
    (pro rata charges do not apply).`
}

export const changeAdaptiveMobilityPlanNew = {
    introText: `Change this service’s current Adaptive Mobility plan to another` +
     ` in the 5G-compatible Mobile, Mobile Broadband and Enterprise Wireless plan range.`,
    firstNote: `Any add-ons associated with an existing plan might be carried over to the newly selected plan.`,
    secondNote: `This change applies once this request is submitted.`,
    thirdNote: `Billing changes take effect from the first day of the next billing month (pro rata charges do not apply).`,
    fourthNote: `Enhanced plans are not available for Enterprise Wireless services.`,
    fifthNote: `For full details refer to the `
}
export const changeAdaptiveMobilityVoicemail = {
    Voice2Text: ' Automatically converts compatible voice messages to texts and sends them to the user’s mobile.',
    messageBank: `If an iPhone is detected, MessageBank Plus is added by default.
     Voicemails are sent directly to a user’s iPhone for instant playback (no need to dial 101)
    and presented as a list with caller ID, if available.`,
    voicemailFirstNotesPoint: 'This service change applies once this request is submitted.',
    voicemailSecondNotesPoint: `Billing changes take effect from the first day of the next
     billing month (pro rata charges do not apply).`,
    voicemailSuspendedService: ` This service is suspended. No changes can be made until this is complete.`,
    voicemailPendingActivationService: ` This service is pending activation.
     No changes can be made until this is complete.`,
    voicemailInstallStatus: `A change cannot be made to this service while another
     change is already in progress. Please try again later.`,
    getVoicemailPlanError: (planType) => `This add-on is not available with ${planType} plans.`,
    identifier: 'VoiceMail'
}
export const enableDisableIRMonthPass = {
    dataSize4gb: `4GB`,
    dataSize8gb: `8GB`,
    introText1: `monthly data allowance with unlimited calls and texts for use in eligible destinations`,
    introText2: `The monthly charge applies regardless of roaming usage.`,
    noteOne: `The International Roaming Month Pass is only available on Adaptive
    Mobility Mobile and Mobile Broadband plans.`,
    noteTwo: `This does not enable or disable international roaming. To do either of these,
    please enable / disable international roaming,
     which will be referenced once you submit this page.`,
    noteThree: `This service change applies once this request is submitted.`,
    noteFour: `Billing changes take effect from the first day of the next
     billing month (pro rata charges do not apply).`,
    identifier: 'IRMonthPass',
    checkBoxLabel: `Agree to change the month pass status`,
    disabledServiceAlert: ` per month for this add-on, from the start of your next billing cycle.
    Pro rata charges do not apply.`,
    modalRecurringCharge: ` Submitting this request may change your recurring charge.`,
    irMonthPassSuspendedService: ` This service is suspended. No changes can be made until this is complete.`,
    irMonthPassPendingActivationService: ` This service is pending activation.
     No changes can be made until this is complete.`,
    irMonthPassInstallStatus: `A change cannot be made to this service while another
     change is already in progress. Please try again later.`,
    irMonthPassExecutivePlanWarning: `The service is on an Executive plan and comes with an
     International Roaming Month Pass, which cannot be changed.`,
    getIrMonthPassPlanError: (planType) => `This add-on is not available with ${planType} plans.`
}
export const internationalDirectDial = {
    basic: 'Unlimited standard calls and SMS from Australia to specific destinations.',
    premium: 'Unlimited standard calls and SMS from Australia to all eligible destinations.',
    iddFirstNote: `This does not enable or disable international calls. To do either of these,
        please use the 'Enable / disable International Direct Dial' form.`,
    iddSecondNote: 'This service change applies once this request is submitted.',
    iddThirdNote: `Billing changes take effect from the first day of the
        next billing month (pro rata charges do not apply).`,
    basicAndPremiumAlert: `Billing charges take effect from the first day of the next billing
        month (pro rata charges do not apply).`,
    noPackAlert: (discontedPrice) => `You will stop being charged ${discontedPrice} per month inc GST for this add-on,
        from the start of your next billing cycle. Pro rata charges do not apply.`,
    identifier: 'IDD',
    iddSuspendedService: ` This service is suspended. No changes can be made until this is complete.`,
    iddPendingActivationService: ` This service is pending activation.
    No changes can be made until this is complete.`,
    iddEpicPlanWarning: `The service is on an Epic plan and comes with a Premium pack, which cannot be changed.`,
    iddExecutivePlanWarning: `The service is on an Executive plan and comes with a Premium pack, which cannot be changed.`,
    iddInstallStatus: `A change cannot be made to this service while another
    change is already in progress. Please try again later.`,
    getIddPlanError: (planType) => `This add-on is not available with ${planType} plans.`,
    modalRecurringCharge: ` Submitting this request may change your recurring charge.`,
    checkBoxLabel: `Agree to change the international call pack?`,
    checkBoxLabelNew: `Agree to change the International calls and SMS pack?`,
    iddModifiedServiceTermsText: ` and eligible International Calls and SMS packs for Adaptive Mobility plans`
}
export const businessDemandData = {
    bddFirstNote: 'Business Demand Data cannot be added if the following are already enabled:' +
        '\n Accelerator, Epic Speed, Epic Speed Trial or Enhanced Speed',
    bddSecondtNote: `This service change applies once this request is submitted.`,
    bddThirdNote: 'Billing changes take effect from the first day of the next' +
        ' billing month (pro rata charges do not apply).',
    disabledServiceAlert: ` per month inc GST for this add-on, from the start of your next billing cycle.
    Pro rata charges do not apply.`,
    enableOtherAddonInfo: `This is because these add-ons cannot be associated to this service at the same time.`,
    bddInstallStatus: `A change cannot be made to this service while another
     change is already in progress. Please try again later.`,
    identifier: `BDD`,
    bddDeactivatedService: `This service is deactivated. No changes can be made.`,
    bddSuspendedService: ` This service is suspended. No changes can be made.`,
    bddPendingActivationService: ` This service is pending activation.
    No changes can be made until this is complete.`,
    getBddPlanError: (planType) => `This add-on is not available with ${planType} plans.`,
    modalRecurringCharge: ` Submitting this request may change your recurring charge.`,
    checkBoxLabel: `Agree to change the Business Demand Data status?`
}
export const apnQuestionTexts = [headerName.sharedApn, headerName.associatedSharedApn, headerName.selectedSharedApn,
    headerName.removeSharedApn, headerName.dedicatedApn, headerName.associatedDedicatedApn,
    headerName.selectedDedicatedApn, headerName.removeDedicatedApn, headerName.existingPlanTypeForPayload,
    headerName.existingPlanForPayload];
export const acceleratorAddOn = {
    acceleratorFirstNote: `Accelerator cannot be added if the following are already enabled:
    Business Demand Data, Epic Speed, Epic Speed Trial or Enhanced Speed.`,
    acceleratorSecondNote: `This service change applies once this request is submitted.`,
    acceleratorThirdNote: `Billing changes take effect from the first day of the next
     billing month (pro rata charges do not apply).`,
    identifier: 'ACCELERATOR',
    messageForGenericAddOn1: ` This is because these add-ons cannot be associated
     to this service at the same time.`,
    messageForGenericAddOnEnabled: (discontedPrice) => `You will stop being charged ${discontedPrice} per month` +
        ' inc GST for this add-on, from the start of your next billing cycle. Pro rata charges do not apply.',
    modalRecurringCharge: ` Submitting this request may change your recurring charge.`,
    checkBoxLabel: `Agree to change the Accelerator status?`,
    acceleratorSuspendedService: ` This service is suspended. No changes can be made until this is complete.`,
    acceleratorPendingActivationService: ` This service is pending activation.
     No changes can be made until this is complete.`,
    acceleratorInstallStatus: `A change cannot be made to this service while another
     change is already in progress. Please try again later.`,
    getAcceleratorPlanError: (planType) => `This add-on is not available with ${planType} plans.`,

}
export const manageDirectoryListing = {
    toolTipInfo: `Unlisted numbers are still accessible to critical government users such as Triple
        Zero, Emergency Alert, law enforcement and national security agencies. For details about
        the Australian Communications and Media Authority's Integrated Public Number Database visit`,
    Unlisted: ` - the account name, address and phone number are not publicly available.`,
    options: `When listing mobile service details, there are two options:`,
    Listed: ` - the account name, address and phone number are shown in phone number directories and related services.`,
    suppressAddress: ` - the account name, suburb and phone number are listed. The service address is not listed.`,
    lastPara: `The public directory listing can only be changed for Mobile plan types. 
        It cannot be changed for Mobile Broadband and Enterprise Wireless plan types, which are data-only.`,
    modalRecurringCharge: ` Submitting this request may change your recurring charge.`,
    checkBoxLabel: `Agree to change the public directory listing status?`,
    directoryListingPendingActivationService: `This service is pending activation. No changes can be made until this is complete.`,
    directoryListingDeactivatedService: `This service is deactivated. No changes can be made.`,
    getDirectoryListingPlanError: `The directory listing cannot be changed for data-only services.`
}

export const LeavingMessage = {
    title: `Are you sure you want to leave this page?`,
    description: `If you leave, any changes you've made on this page won't be saved.`,
    confirmButtonLabel: `Yes, leave this page`,
    cancelButtonLabel: `Go back`
}

export const CancelConfirmationMessage = {
    title: 'Are you sure you want to cancel?',
    description: `Any changes you've made on this page won't be saved.`,
    confirmButtonLabel: 'Yes, cancel changes',
    cancelButtonLabel: 'Go back',
}

export const DefaultConfig = {
    PAGE_INDEX: 1,
    PAGE_SIZE: 100,
    SORT_BY: 'serviceNumber',
    SORT_ORDER: 'ASC',
}

export enum DeactivateErrorMessagelabels {
    Title = 'Data not available right now',
    SubHeading = 'We couldn\'t find the page you requested',
    HelperText = 'Refresh the page or submit a support enquiry if there\'s still a problem.',
    primaryButtonLabel = 'Refresh page',
    secondaryButtonLabel = 'Submit enquiry'
}
